<template>
  <div :class="['animated fadeIn overflow-auto', { 'pedido-dark': isDark }]">
    <div class="pre-scrollable  " style="max-height: 75vh; overflow-x: hidden;">
      <!-- Modernized Mobile Navbar -->
      <div class="sticky-top bg-white border-bottom shadow-sm" style="z-index: 1020;">
        <!-- Top Row: Navigation and Main Order Info -->
        <div class="d-flex align-items-center p-1 mb-2">
          <div class="bg-info text-white d-flex align-items-center justify-content-center mr-3 shadow-sm hover-effect" 
               style="width: 44px; height: 44px; border-radius: 12px; flex-shrink: 0;" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left font-lg"></i>
          </div>
          
          <div class="flex-grow-1 overflow-hidden">
            <div class="d-flex align-items-center justify-content-between mb-0">
              <span class="font-weight-bold text-dark mr-2 text-truncate" style="font-size: 1.1rem; letter-spacing: -0.5px;">
                {{venda.SEQUENCIA > 0 ? 'PEDIDO #' + venda.SEQUENCIA : 'NOVO PEDIDO'}}
              </span>
              <b-badge :variant="variantSituacao(venda.SITUACAO)" pill class="px-2 py-1" style="font-size: 0.55rem; font-weight: 800; white-space: nowrap; flex-shrink: 0;">
                {{traduzirSituacao(venda.SITUACAO)}}
              </b-badge>
            </div>
            <div class="text-muted text-uppercase text-truncate" style="font-size: 0.7rem; font-weight: 600; letter-spacing: 0.3px;">
              <span class="text-truncate"><i class="fa fa-user-o mr-1"></i>{{cliente.CODIGO}} - {{cliente.NOME}}</span>
            </div>
          </div>
        </div>

        <!-- Summary Floating Card (Distinguishable from Tabs) -->
        <div class="px-1 pb-3">
          <div class="d-flex align-items-center p-2 shadow-sm" style="border-radius: 14px; background: #eef2f6; border: 1px solid #dfe6ed;">
            <div class="flex-fill text-center">
               <div class="text-muted text-uppercase font-weight-bold" style="font-size: 0.5rem; letter-spacing: 0.5px;">Produtos</div>
               <div class="text-dark font-weight-bold mb-0" style="font-size: 0.9rem;">{{totalItensLancados}} <small class="text-muted font-weight-normal" style="font-size: 0.6rem;">ITENS</small></div>
            </div>
            <div class="bg-secondary-light" style="width: 1px; height: 24px; background: rgba(0,0,0,0.05);"></div>
            <div class="flex-fill text-center">
               <div class="text-muted text-uppercase font-weight-bold" style="font-size: 0.5rem; letter-spacing: 0.5px;">Peças</div>
               <div class="text-dark font-weight-bold mb-0" style="font-size: 0.9rem;">{{totalPecas}} <small class="text-muted font-weight-normal" style="font-size: 0.6rem;">QTD</small></div>
            </div>
            <div class="bg-secondary-light" style="width: 1px; height: 24px; background: rgba(0,0,0,0.05);"></div>
            <div class="flex-fill text-center px-1">
               <div class="text-primary text-uppercase font-weight-bold" style="font-size: 0.5rem; letter-spacing: 0.5px;">Total Líquido</div>
               <div class="text-primary font-weight-bold mb-0" style="font-size: 1.05rem; letter-spacing: -0.5px; line-height: 1;">
                 {{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
               </div>
            </div>
          </div>
        </div>
      </div>
    
      <b-card no-body class="border-0 shadow-none bg-transparent">
              <b-tabs v-model="tabIndex" fill class="modern-tabs-container">
                <b-tab class="bg-gray-100 p-0" active :title-link-class="colorirTabSelecionada(0)">
                  <template #title>
                     <div class="tab-content-wrapper">
                        <i class="icon-note icons font-lg d-block mb-0"></i>
                        <span class="tab-label" style="font-size: 0.55rem;">DADOS</span>
                     </div>
                  </template>

                  <div class="p-2">
                    <!-- Section: Cliente e Vendedor -->
                    <div class="bg-white p-3 shadow-sm mb-2" style="border-radius: 12px;">
                       <div class="d-flex align-items-center mb-3">
                        <div class="bg-info mr-2" style="width: 4px; height: 18px; border-radius: 2px;"></div>
                        <h6 class="mb-0 font-weight-bold text-uppercase" style="letter-spacing: 0.5px; font-size: 0.8rem;">Identificação</h6>
                      </div>
                      <b-row>
                        <b-col sm="6">
                           <cliente-pesquisa 
                                          @retornaId="venda.COD_CLI = $event"
                                          :idInicial="venda.COD_CLI"
                                          :classe-required="!valCOD_CLI"
                                          :desabilitarInput="controles.vendaAlteracao"
                                          idModal="modalCliente"
                                          :labelVermelho="controles.clienteBloqueado"
                                          :label="controles.situacaoCliente"
                                          :exibirBloqueado="controles.clienteBloqueado"
                                          id="edCOD_CLI"
                                          ref="edCOD_CLI"
                                          place="Selecionar Cliente..."
                                          labelBotao="">
                          </cliente-pesquisa>
                        </b-col>
                        <b-col sm="6" class="mt-2 mt-sm-0">
                          <vendedor-pesquisa 
                                              @retornaId="venda.COD_VENDEDOR = $event"
                                              :idInicial="venda.COD_VENDEDOR"
                                              :classe-required="!valCOD_VENDEDOR"
                                              :desabilitarInput="controles.fechada"
                                              label="Vendedor"
                                              place="Vendedor Responsável..."
                                              labelBotao="">
                            </vendedor-pesquisa>
                        </b-col>
                      </b-row>

                      <!-- Compact Client Info Row -->
                      <div v-if="venda.COD_CLI" class="d-flex justify-content-between mt-2 pt-2 border-top" style="line-height: 1.1;">
                        <div class="text-truncate mr-1">
                          <small class="text-muted font-weight-bold text-uppercase" style="font-size: 0.5rem; letter-spacing: 0.2px;">LIMITE:</small>
                          <span class="font-weight-bold text-success ml-1" style="font-size: 0.6rem;">{{limiteCredito.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL', minimumFractionDigits: 0})}}</span>
                        </div>
                        <div class="text-truncate mr-1 text-center">
                          <small class="text-muted font-weight-bold text-uppercase" style="font-size: 0.5rem; letter-spacing: 0.2px;">DUPLIC:</small>
                          <span class="font-weight-bold text-info ml-1" style="font-size: 0.6rem;">{{cliente.NOTAS_EM_ABERT0}}</span>
                        </div>
                        <div class="text-truncate text-right">
                          <small class="text-muted font-weight-bold text-uppercase" style="font-size: 0.5rem; letter-spacing: 0.2px;">ICMS:</small>
                          <span class="font-weight-bold ml-1 text-uppercase" style="font-size: 0.6rem;" :class="cliente.ISENTO_ICMS == 1 ? 'text-success' : 'text-warning'">
                            {{cliente.ISENTO_ICMS ? (cliente.ISENTO_ICMS == 1 ? 'ISENTO' : 'SUJ') : 'AUS'}}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Modernized Professional Items Header - Moved from ITENS tab -->
                    <div class="px-0 pt-0 w-100" style="overflow-x: hidden;">
                      <div class="items-header-professional mb-2 p-2 px-3 bg-white shadow-sm d-flex justify-content-between align-items-center" style="border-radius: 0 12px 12px 0; margin-left: 0; margin-right: 4px;">
                        <div class="d-flex align-items-center" style="min-width: 0; flex: 1;">
                          <div class="icon-indicator bg-info mr-2" style="width: 4px; height: 18px; flex-shrink: 0;"></div>
                          <div class="text-truncate">
                            <h5 class="mb-0 font-weight-bold text-dark text-truncate" style="font-size: 0.85rem; letter-spacing: -0.3px;">ITENS</h5>
                            <div class="d-flex align-items-center mt-0">
                              <b-badge pill variant="info" class="mr-2" style="font-size: 0.55rem; padding: 2px 5px;">{{ tabelaItens.items.length }}</b-badge>
                              <small class="text-muted text-uppercase font-weight-bold text-truncate" style="font-size: 0.5rem; letter-spacing: 0.5px;">PRODUTOS</small>
                            </div>
                          </div>
                        </div>
                        <b-button v-if="habilitaBotaoProdutos"
                                  variant="primary" 
                                  class="btn-add-modern-pro ml-2 px-3" 
                                  style="border-radius: 10px; font-weight: 700; height: 38px; font-size: 0.75rem;"
                                  @click="abrirModalListaDeProdutos()" > 
                            <i class="fa fa-plus-circle mr-1"></i> ADICIONAR
                        </b-button>
                      </div>
                      
                      <div class="w-100 p-0">
                          <b-table 
                                  class="mb-0 w-100" 
                                  no-border-collapse
                                  tbody-tr-class="bg-transparent"
                                  :items="tabelaItens.items" 
                                  :fields="tabelaItens.fields"
                                  @row-clicked="abrirModalAlterarProduto"
                                  style="table-layout: fixed;"
                                  thead-class="d-none">
                            
                            <template #cell(item)="row"> 
                              <div class="item-card-pedido-wrap">
                                <div class="item-card-pedido">
                                  <div class="card-header-pedido">
                                    <div class="title-section">
                                      <h4 class="product-name" :title="row.item.CODIGO_NOME_PRODUTO">{{row.item.CODIGO_NOME_PRODUTO}}</h4>
                                      <span class="group-name" :title="row.item.NOME_GRUPO">{{row.item.NOME_GRUPO}}</span>
                                    </div>
                                    <div class="action-section" v-if="!controles.fechada">
                                      <b-button size="sm" variant="light" class="btn-delete-item" @click.stop.prevent="abrirModalExcluirItem(row.item)">
                                        <i class="fa fa-trash text-danger"></i>
                                      </b-button>
                                    </div>
                                  </div>

                                  <div class="card-body-pedido">
                                    <div class="info-group">
                                      <div class="info-item">
                                         <span class="label">PECAS</span>
                                         <span class="value text-primary text-truncate">{{row.item.PECAS_PEDIDO}}</span>
                                      </div>
                                      <div class="info-item">
                                        <span class="label">PREÇO</span>
                                        <span class="value text-truncate">{{row.item.VL_UNT}}</span>
                                      </div>
                                      <div class="info-item">
                                        <span class="label">TOTAL</span>
                                        <span class="value text-success font-weight-bold text-truncate">
                                           {{ formatarMoeda(totalPrevistoItem(row.item)) }}
                                        </span>
                                      </div>
                                    </div>

                                    <div class="rep-section">
                                       <span class="label">REPESAR</span>
                                       <div v-if="!controles.fechada" @click.stop>
                                          <label class="switch switch-sm switch-text switch-info mb-0" style="margin-right: -5px;">
                                            <input type="checkbox" class="switch-input" v-model="row.item.OP_REPESAR">
                                            <span class="switch-label" data-on="S" data-off="N"></span>
                                            <span class="switch-handle"></span>
                                          </label>
                                       </div>
                                       <div v-else>
                                          <b-badge pill :variant="row.item.OP_REPESAR ? 'danger' : 'light'" style="font-size: 0.6rem;">
                                            {{row.item.OP_REPESAR ? 'S' : 'N'}}
                                          </b-badge>
                                       </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </b-table>
                      </div>
                    </div>
                  </div>
                </b-tab>
                 <b-tab :title-link-class="colorirTabSelecionada(1)">
                    <template #title>
                      <div class="tab-content-wrapper">
                        <i class="icon-calculator icons font-lg d-block mb-0"></i>
                        <span class="tab-label" style="font-size: 0.55rem;">PAGTO</span>
                      </div>
                    </template>
                    
                    <div class="p-2">
                      <!-- Section: Condições de Pagamento -->
                      <div class="bg-white p-0 shadow-sm mb-2" style="border-radius: 12px;">
                        <div class="d-flex align-items-center mb-3">
                          <div class="bg-warning mr-2" style="width: 4px; height: 18px; border-radius: 2px;"></div>
                          <h6 class="mb-0 font-weight-bold text-uppercase" style="letter-spacing: 0.5px; font-size: 0.8rem;">Pagamento</h6>
                        </div>

                        <b-row>
                          <b-col cols="12" md="4" class="mb-2">
                            <label class="text-muted font-weight-bold text-uppercase mb-1 d-block" style="font-size: 0.65rem;">Forma</label>
                            <b-form-select :plain="true" 
                                          class="form-control-modern"
                                          :disabled="controles.fechada" 
                                          v-model="venda.OP_FORMA_PAGTO"
                                          :state="venda.OP_FORMA_PAGTO != null"  
                                          :options="tipoPagamento">
                            </b-form-select>
                          </b-col>

                          <b-col cols="12" md="8" v-if="venda.OP_FORMA_PAGTO === 'P'">
                            <div class="bg-light p-2 rounded mb-2">
                               <label class="text-muted font-weight-bold text-uppercase mb-2 d-block" style="font-size: 0.6rem;">Atalhos de Vencimento</label>
                               <div class="d-flex flex-wrap">
                                  <b-button v-for="dias in diasSugestaoOrdenados" :key="dias"
                                    size="sm" class="mr-1 mb-1 shadow-sm"
                                    :variant="dias === diasSelecionados ? 'primary' : 'white'"
                                    style="font-size: 0.65rem; border-radius: 6px; font-weight: 700;"
                                    @click="adicionarDiasInicioPagamento(dias)">
                                    +{{ dias }} DIAS
                                  </b-button>
                               </div>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row v-if="venda.OP_FORMA_PAGTO === 'P'">
                          <b-col cols="12" md="12" class="mb-3">
                             <label class="text-muted font-weight-bold text-uppercase mb-1 d-block" style="font-size: 0.65rem;">{{textoInicioPagamento}}</label>
                             <b-form-input type="date" class="form-control-modern" :disabled="controles.fechada" v-model="venda.DT_INICIAR_PAGAMENTO"/>
                          </b-col>
                          <b-col cols="6" md="6">
                             <label class="text-muted font-weight-bold text-uppercase mb-1 d-block" style="font-size: 0.65rem;">Vezes</label>
                             <b-form-select class="form-control-modern" v-model="venda.NR_PARCELAS" :disabled="controles.fechada" :options="parcelasVezes"/>
                          </b-col>
                          <b-col cols="6" md="6">
                             <label class="text-muted font-weight-bold text-uppercase mb-1 d-block" style="font-size: 0.65rem;">Interv</label>
                             <b-form-select class="form-control-modern" v-model="venda.PAG1" :disabled="controles.fechada" :options="dias"/>
                          </b-col>
                        </b-row>
                      </div>

                      <!-- Section: Total Geral -->
                      <div class="bg-primary text-white p-3 shadow mb-2" style="border-radius: 12px; background: linear-gradient(135deg, #20a8d8 0%, #178ab3 100%);">
                         <div class="text-uppercase font-weight-bold mb-1" style="font-size: 0.6rem; opacity: 0.9; letter-spacing: 1px;">Valor Total do Pedido</div>
                         <div class="d-flex align-items-baseline">
                           <span class="mr-2" style="font-size: 1.2rem; opacity: 0.8; font-weight: 600;">R$</span>
                           <h2 class="mb-0 font-weight-bold" style="font-size: 2.2rem; letter-spacing: -1px;">
                              {{totalVenda.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}
                           </h2>
                         </div>
                         <div class="d-flex mt-3 pt-2 border-top" style="border-color: rgba(255,255,255,0.1) !important;">
                            <div class="flex-fill">
                                <small class="d-block text-uppercase font-weight-bold" style="font-size: 0.55rem; opacity: 0.8;">Peso Prev.</small>
                                <span class="font-weight-bold">{{Number(venda.QUANT_PEDIDO || 0).toFixed(2)}} <small>KG</small></span>
                            </div>
                            <div class="flex-fill">
                               <small class="d-block text-uppercase font-weight-bold" style="font-size: 0.55rem; opacity: 0.8;">Produtos</small>
                               <span class="font-weight-bold">{{venda.VL_TOTAL_PRODUTOS.toLocaleString('pt-BR', {style:'currency', currency:'BRL'})}}</span>
                            </div>
                         </div>
                      </div>

                      <!-- Section: Detalhamento de Impostos e Valores -->
                      <div class="bg-white p-3 shadow-sm mb-2" style="border-radius: 12px;">
                         <div class="d-flex align-items-center mb-3">
                          <div class="bg-info mr-2" style="width: 4px; height: 18px; border-radius: 2px;"></div>
                          <h6 class="mb-0 font-weight-bold text-uppercase" style="letter-spacing: 0.5px; font-size: 0.8rem;">Detalhamento</h6>
                        </div>
                        
                        <div class="detail-row d-flex justify-content-between mb-2 pb-1 border-bottom">
                           <span class="text-muted small font-weight-bold">ICMS / ST</span>
                           <span class="font-weight-bold text-dark small">{{(venda.VL_TOTAL_ICMS + venda.VL_TOTAL_ST_ICMS).toLocaleString('pt-BR', {style:'currency', currency:'BRL'})}}</span>
                        </div>
                        <div class="detail-row d-flex justify-content-between mb-2 pb-1 border-bottom">
                           <span class="text-muted small font-weight-bold">IPI / PIS / COFINS</span>
                           <span class="font-weight-bold text-dark small">{{(venda.VL_TOTAL_IPI + venda.VL_TOTAL_PIS + venda.VL_TOTAL_COFINS).toLocaleString('pt-BR', {style:'currency', currency:'BRL'})}}</span>
                        </div>
                        <div class="detail-row d-flex justify-content-between mb-2 pb-1 border-bottom">
                           <span class="text-muted small font-weight-bold">FRETE / SEGURO</span>
                           <span class="font-weight-bold text-dark small">{{(venda.VL_TOTAL_FRETE + venda.VL_TOTAL_SEGURO).toLocaleString('pt-BR', {style:'currency', currency:'BRL'})}}</span>
                        </div>
                        <div class="detail-row d-flex justify-content-between mb-0">
                           <span class="text-danger small font-weight-bold">(-) DESCONTOS</span>
                           <span class="font-weight-bold text-danger small">{{venda.VL_TOTAL_DESCONTO.toLocaleString('pt-BR', {style:'currency', currency:'BRL'})}}</span>
                        </div>
                      </div>

                      <!-- Section: Observações -->
                      <div class="bg-white p-3 shadow-sm mb-2" style="border-radius: 12px;">
                         <div class="d-flex align-items-center mb-2">
                          <div class="bg-secondary mr-2" style="width: 4px; height: 18px; border-radius: 2px;"></div>
                          <h6 class="mb-0 font-weight-bold text-uppercase" style="letter-spacing: 0.5px; font-size: 0.8rem;">Observações</h6>
                        </div>
                        <b-form-textarea
                            class="form-control-modern border-0 bg-light"
                            :disabled="controles.fechada" 
                            v-model="venda.OBS_PEDIDO"
                            placeholder="Notas adicionais sobre o pedido..."
                            rows="3"
                            max-rows="5">
                        </b-form-textarea>
                      </div>

                      <!-- Actions -->
                      <div class="px-1 mt-4">
                        <b-button v-if="((!controles.fechada) && (controles.clienteBloqueado == true))"
                            block variant="danger" size="lg" 
                            style="border-radius: 14px; font-weight: 800; height: 60px; letter-spacing: 0.5px;">
                            <i class="fa fa-lock mr-2"></i> CLIENTE BLOQUEADO
                        </b-button>  
                        <b-button v-else-if="!controles.fechada"
                            block variant="success" size="lg"
                            style="border-radius: 14px; font-weight: 800; height: 60px; letter-spacing: 0.5px; box-shadow: 0 4px 15px rgba(40,167,69,0.3);"
                            @click="finalizarVenda()">
                            <i class="fa fa-check-circle mr-2"></i> FINALIZAR PEDIDO
                        </b-button>

                        <b-button v-if="habilitaBotaoExcluir" size="lg" block variant="outline-danger" class="mt-2"
                            style="border-radius: 14px; font-weight: 800; height: 50px; border-width: 2px;" 
                            @click="abrirModalCancelamento()"> 
                            <i class="fa fa-trash mr-2"></i> EXCLUIR PEDIDO
                        </b-button>

                        <div v-if="controles.fechada" class="d-flex flex-column gap-2">
                          <b-button v-if="venda.SITUACAO != '0'" block size="lg" variant="warning" class="mb-2"
                              style="border-radius: 14px; font-weight: 800; height: 50px;" 
                              @click="abrirModalReabrir()"> 
                              <i class="fa fa-unlock mr-2"></i> REABRIR
                          </b-button>
                        </div>
                      </div>
                    </div>
                 </b-tab>
              </b-tabs>
      </b-card>

      <!--/.row-->
    
    </div>
     

    <!--  -----------------------------------------------------------------------------------
                                          MODAL ITENS 
            ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modal-lista-produtos" 
            id="modal-lista-produtos" 
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            scrollable 
            :modal-class="['modal-luxury', isDark ? 'pedido-modal-dark' : '']"
            body-class="p-0"
            button-size="lg"
            centered>
            <template #modal-header="{ close }">
                <div class="w-100">
                  <b-input-group >
                    <b-form-input
                      id="filter-input"
                      v-model="filter"
                      filter-debounce="300"
                      class="modern-search"
                      type="search"
                      placeholder="Pesquisar por Código ou Nome...">
                    </b-form-input>
                    <b-input-group-append>
                      <b-button variant="light" class="btn-search-back" type="button" @click.stop.prevent="fecharModalListaProdutos()" > 
                        <i class="fa fa-arrow-left"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-flex mt-2">
                    <b-button-group class="w-100 px-1" size="sm">
                      <b-button :variant="!apenasLancados ? 'primary' : 'outline-primary'" 
                                @click="apenasLancados = false" 
                                style="font-size: 0.7rem; font-weight: bold; border-radius: 6px 0 0 6px;">
                        ESTOQUE
                      </b-button>
                      <b-button :variant="apenasLancados ? 'primary' : 'outline-primary'" 
                                @click="apenasLancados = true" 
                                style="font-size: 0.7rem; font-weight: bold; border-radius: 0 6px 6px 0;">
                        SELECIONADOS
                      </b-button>
                    </b-button-group>
                  </div>
                </div>
            </template>

            <div class="px-0 py-1">
                  <div v-if="estoqueCriticaModal.visivel" class="stock-banner-modal mx-2 mt-2 mb-1">
                    <div class="stock-banner-title">Saldo atualizado durante a selecao</div>
                    <div class="stock-banner-message">{{ estoqueCriticaModal.mensagem }}</div>
                    <div
                      v-for="item in estoqueCriticaModal.itens"
                      :key="`critica-estoque-${item.PRODUTO_ID}`"
                      class="stock-banner-item">
                      {{ item.DESCRICAO_PRODUTO }}: solicitado {{ item.PECAS_PEDIDO_SOLICITADO }}, disponivel agora {{ item.PECAS_DISPONIVEIS_ATUAL }}, ajustado para {{ item.PECAS_PEDIDO_AJUSTADO }}.
                    </div>
                  </div>

                  <b-table 
                          id="tabela-lista-produtos"
                          ref="tabela-lista-produtos"
                          class="mb-0 w-100" 
                          no-border-collapse
                          tbody-tr-class="bg-transparent"
                          :items="filteredProducts" 
                          :fields="produtos.campos"
                          primary-key="PRODUTO_ID" 
                          :current-page="produtos.currentPage"
                          :per-page="produtos.perPage"
                          :filter="filter"
                          :filter-included-fields="['DESCRICAO_PRODUTO']"
                          :filter-ignored-fields="['PRODUTO_ID','PECAS','UNIDADE_COMERCIAL_ID','PECAS_PEDIDO','DESCRICAO_GRUPO']"
                          thead-class="d-none"
                          @filtered="onFiltered">
                    
                    <template #cell(PRODUTO_ID)="linha"> 
                      <div :class="['product-card-pro', { 'is-selected': linha.item.PECAS_PEDIDO > 0, 'has-stock-conflict': linha.item._estoqueCritico }]">
                        <!-- Header: Code and Name -->
                        <div class="card-header-pro">
                          <h3 class="product-title text-truncate">{{ linha.item.DESCRICAO_PRODUTO }}</h3>
                          <b-badge variant="primary" class="unit-badge">{{ linha.item.UNIDADE_COMERCIAL_ID }}</b-badge>
                        </div>

                        <div v-if="linha.item._estoqueCritico" class="stock-inline-warning">
                          Saldo disponivel atualizado para {{ linha.item.PECAS }} unidade(s).
                        </div>

                        <!-- Info Grid -->
                        <div class="product-info-grid product-info-grid-estimate">
                          <div class="info-item">
                            <span class="info-label">DISPONÍVEL</span>
                            <span :class="['info-value', linha.item.PECAS > 0 ? 'text-success' : 'text-danger']">
                              {{ linha.item.PECAS > 0 ? linha.item.PECAS : 'ZERO' }}
                            </span>
                          </div>
                          <div class="info-item">
                            <span class="info-label">QUANTIDADE</span>
                            <span class="info-value estimate-qty">{{ formatarPeso(quantidadePrevistaProduto(linha.item)) }}</span>
                          </div>
                          <div class="info-item">
                            <span class="info-label">TOTAL R$</span>
                            <span class="info-value estimate-total">{{ formatarMoeda(totalPrevistoProduto(linha.item)) }}</span>
                          </div>
                          <div class="info-item">
                            <span class="info-label">GRUPO</span>
                            <span class="info-value text-dark text-truncate">{{ linha.item.DESCRICAO_GRUPO }}</span>
                          </div>
                        </div>

                        <!-- Actions Area -->
                        <div class="card-actions-pro">
                          <div class="price-box">
                            <div class="price-header">
                              <span class="price-label">PREÇO VENDA</span>
                              <span class="last-price" @click.stop.prevent="usarPreco(linha.item)">
                                <i class="fa fa-history"></i> ULT: {{ Number(linha.item.ULTIMO_PRECO || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                              </span>
                            </div>
                            <b-input-group size="sm">
                              <b-input-group-prepend is-text>
                                <span class="text-muted small">R$</span>
                              </b-input-group-prepend>
                              <vue-autonumeric v-model="linha.item.VL_UNT"
                                :options="{
                                  digitGroupSeparator: '.',
                                  decimalCharacter: ',',
                                  decimalCharacterAlternative: '.',
                                  decimalPlaces: '2',
                                  roundingMethod: 'U',
                                  minimumValue: '0'
                                }"
                                :class="['form-control input-price-pro', { 
                                  'has-value': linha.item.VL_UNT > 0,
                                  'is-invalid': (linha.item.PECAS_PEDIDO > 0) && (linha.item.VL_UNT <= 0)
                                }]">
                              </vue-autonumeric>
                            </b-input-group>
                          </div>

                          <div class="quantity-box">
                            <span class="qty-label text-right">QUANTIDADE</span>
                            <b-input-group size="sm">
                              <b-input-group-prepend>
                                <b-button variant="outline-danger" class="btn-qty-pro"
                                  @touchstart="handleMouseDownDecrementarItem(linha.item)"
                                  @touchend="handleMouseUpDecrementarItem(linha.item)"
                                  @touchcancel="handleMouseLeaveDecrementarItem()"
                                  @contextmenu.prevent>
                                  <i class="fa fa-minus"></i>
                                </b-button>
                              </b-input-group-prepend>
                              
                              <vue-autonumeric v-model="linha.item.PECAS_PEDIDO"
                                :options="{
                                  digitGroupSeparator: '.',
                                  decimalCharacter: ',',
                                  decimalCharacterAlternative: '.',
                                  decimalPlaces: '0',
                                  roundingMethod: 'U',
                                  minimumValue: '0',
                                  maximumValue: linha.item.PECAS.toString()
                                }"
                                :disabled="true"
                                :class="['form-control input-qty-pro', { 'has-value': linha.item.PECAS_PEDIDO > 0 }]">
                              </vue-autonumeric>

                              <b-input-group-append>
                                <b-button variant="success" class="btn-qty-pro"
                                  @touchstart="handleMouseDownAcrescentarItem(linha.item)"
                                  @touchend="handleMouseUpAcrescentarItem(linha.item)"
                                  @touchcancel="handleMouseLeaveAcrescentarItem()"
                                  @contextmenu.prevent>
                                  <i class="fa fa-plus"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </div>
                        </div>
                        
                        <!-- Variations (Special Case) -->
                        <div v-if="linha.item.OP_BANDA === '1' && Array.isArray(linha.item.DERIVADOS)" class="variations-panel">
                           <div v-for="(derivado, index) in linha.item.DERIVADOS" :key="index" class="variation-item">
                              <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="variation-label">VARIAÇÃO {{index + 1}}</span>
                                <span class="variation-history" @click.stop.prevent="usarPreco(derivado)">
                                  ULT: {{ Number(derivado.ULTIMO_PRECO || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                                </span>
                              </div>
                              <vue-autonumeric v-model="derivado.VL_UNT"
                                :options="{
                                  digitGroupSeparator: '.',
                                  decimalCharacter: ',',
                                  decimalCharacterAlternative: '.',
                                  decimalPlaces: '2',
                                  roundingMethod: 'U',
                                  minimumValue: '0'
                                }"
                                :class="['form-control input-price-pro sm', { 'has-value': derivado.VL_UNT > 0 }]">
                              </vue-autonumeric>
                           </div>
                        </div>
                      </div>
                    </template>
                  </b-table>
            </div>
            
            <template #modal-footer="{ cancel }">
              <div class="footer-pro w-100 p-2 bg-white border-top">
                <div class="d-flex justify-content-between align-items-center mb-2 px-2">
                  <div class="summary-selection text-left">
                    <div class="item-resumo">QTD: <strong>{{ resumoSelecaoModal.quant }}</strong></div>
                    <div class="item-resumo font-weight-bold text-primary"> {{ resumoSelecaoModal.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</div>
                  </div>
                  
                  <div class="d-flex align-items-center">
                    <b-pagination 
                        size="sm"
                        v-model="produtos.currentPage"
                        :total-rows="produtos.totalRows" 
                        :per-page="produtos.perPage" 
                        limit="1"
                        hide-goto-end-buttons
                        prev-text="<"
                        next-text=">"
                        class="pagination-modern mb-0"
                    />
                  </div>
                </div>
                <b-button variant="primary" class="btn-concluir shadow-sm" @click.stop.prevent="fecharModalListaProdutos()" > 
                   <i class="fa fa-check-circle mr-2"></i> CONCLUIR SELEÇÃO
                </b-button>
              </div>
          </template>
        </b-modal>
    </div>

    <!--  -----------------------------------------------------------------------------------
                                          MODAL ALTERAR ITEM 
    ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-alterar-item" 
          id="modal-alterar-item" 
          hide-header
          body-class="p-0"
          centered
          :modal-class="['modal-luxury', isDark ? 'pedido-modal-dark' : '']"
          button-size="lg">
        <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                    no-wrap 
                    fixed 
                    z-index="1100" 
                    spinner-variant="primary"
                    spinner-type="border">
          <template #overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p>Por favor. Aguarde!!!...</p>
            </div>
          </template>
        </b-overlay>
        
        <div class="p-3">
          <div class="product-card-pro is-selected mb-0">
            <!-- Header -->
            <div class="card-header-pro d-flex justify-content-between align-items-center">
              <h3 class="product-title mb-0" style="white-space: normal;">{{itemAlteracao.CODIGO_NOME_PRODUTO}}</h3>
              <b-button variant="light" size="sm" class="rounded-circle" @click="$refs['modal-alterar-item'].hide()">
                <i class="fa fa-times"></i>
              </b-button>
            </div>

            <!-- Info Grid -->
            <div class="product-info-grid">
              <div class="info-item">
                <span class="info-label">PREÇO ATUAL</span>
                <span class="info-value text-primary font-weight-bold">{{itemAlteracao.VL_UNT_MASK}}</span>
              </div>
              <div class="info-item">
                <span class="info-label">ESTOQUE DISPONÍVEL</span>
                <span :class="['info-value', itemAlteracao.PECAS_ESTOQUE > 0 ? 'text-success' : 'text-danger']">
                  {{(itemAlteracao.PECAS_ESTOQUE != pecasEstoqueNegativo ? itemAlteracao.PECAS_ESTOQUE : '0')}}
                </span>
              </div>
            </div>

            <!-- Quantity Control -->
            <div class="card-actions-pro mt-3">
              <div class="quantity-box w-100">
                <span class="qty-label text-center mb-2">AJUSTAR QUANTIDADE NO PEDIDO</span>
                <b-input-group size="lg">
                  <b-input-group-prepend>
                    <b-button variant="outline-danger" class="btn-qty-pro"
                      @touchstart="handleMouseDownDecrementarItemAlteracao()"
                      @touchend="handleMouseUpDecrementarItemAlteracao()"
                      @touchcancel="handleMouseLeaveDecrementarItemAlteracao()"
                      @contextmenu.prevent>
                      <i class="fa fa-minus"></i>
                    </b-button>
                  </b-input-group-prepend>
                  
                  <vue-autonumeric v-model="itemAlteracao.PECAS_PEDIDO"
                    :options="{
                      digitGroupSeparator: '.',
                      decimalCharacter: ',',
                      decimalCharacterAlternative: '.',
                      decimalPlaces: '0',
                      roundingMethod: 'U',
                      minimumValue: '0',
                      maximumValue: itemAlteracao.PECAS_ESTOQUE ? itemAlteracao.PECAS_ESTOQUE.toString() : '999999'
                    }"
                    :disabled="true"
                    :class="['form-control input-qty-pro', { 'has-value': itemAlteracao.PECAS_PEDIDO > 0 }]">
                  </vue-autonumeric>

                  <b-input-group-append>
                    <b-button variant="success" class="btn-qty-pro"
                      @touchstart="handleMouseDownAcrescentarItemAlteracao()"
                      @touchend="handleMouseUpAcrescentarItemAlteracao()"
                      @touchcancel="handleMouseLeaveAcrescentarItemAlteracao()"
                      @contextmenu.prevent>
                      <i class="fa fa-plus"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </div>
          </div>
        </div>

        <template #modal-footer="{ cancel }">
          <div class="footer-pro w-100 p-3 bg-white border-top">
             <b-button block variant="primary" class="btn-concluir shadow-sm" @click="alterarItem()">
                <i class="fa fa-save mr-2"></i> GRAVAR ALTERAÇÕES
             </b-button>
             <button class="btn btn-block btn-light mt-2 text-muted font-weight-bold" @click="cancel()" style="border-radius: 10px; height: 48px;">
                CANCELAR
             </button>
          </div>
        </template>
      </b-modal>
    </div>

    
    <!--  -----------------------------------------------------------------------------------
                                          MODAL EXCLUIR ITEM 
            ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modal-excluir-item" 
            id="modal-excluir-item" 
            hide-header
            body-class="p-0"
            centered
            :modal-class="['modal-luxury', isDark ? 'pedido-modal-dark' : '']"
            button-size="lg">
          <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                      no-wrap 
                      fixed 
                      z-index="1100" 
                      spinner-variant="primary"
                      spinner-type="border">
            <template #overlay>
              <div class="text-center">
                <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                <p>Por favor. Aguarde!!!...</p>
              </div>
            </template>
          </b-overlay>
          
          <div class="p-3">
            <div class="product-card-pro is-selected mb-0 border-danger">
              <!-- Header -->
              <div class="card-header-pro d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div class="bg-danger rounded-circle mr-2 d-flex align-items-center justify-content-center" style="width: 32px; height: 32px;">
                    <i class="fa fa-trash text-white"></i>
                  </div>
                  <h3 class="product-title mb-0" style="white-space: normal;">{{itemExcluir.CODIGO_NOME_PRODUTO}}</h3>
                </div>
                <b-button variant="light" size="sm" class="rounded-circle" @click="$refs['modal-excluir-item'].hide()">
                  <i class="fa fa-times"></i>
                </b-button>
              </div>

              <div class="px-3 py-2 text-center">
                <p class="text-muted mb-0 font-weight-bold" style="font-size: 0.85rem;">VOCÊ ESTÁ REMOVENDO ESTE ITEM DO PEDIDO</p>
              </div>

              <!-- Info Grid -->
              <div class="product-info-grid mt-2">
                <div class="info-item">
                  <span class="info-label">PREÇO UNIT.</span>
                  <span class="info-value text-dark font-weight-bold">{{itemExcluir.VL_UNT_MASK}}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">QTD NO PEDIDO</span>
                  <span class="info-value text-danger font-weight-bold">{{itemExcluir.PECAS_PEDIDO}} UND</span>
                </div>
              </div>

              
            </div>
          </div>

          <template #modal-footer="{ cancel }">
            <div class="footer-pro w-100 p-3 bg-white border-top">
               <b-button block variant="danger" class="btn-concluir shadow-sm border-0" @click="excluirItem()" style="background: #e55353;">
                  <i class="fa fa-trash-o mr-2"></i> CONFIRMAR REMOÇÃO
               </b-button>
               <button class="btn btn-block btn-light mt-2 text-muted font-weight-bold" @click="cancel()" style="border-radius: 10px; height: 48px;">
                  MANTER NO PEDIDO
               </button>
            </div>
          </template>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL REABRIR VENDA 
            ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modal-reabrir" 
            id="modal-reabrir" 
            hide-header
            centered
            body-class="p-0"
            :modal-class="['modal-luxury', isDark ? 'pedido-modal-dark' : '']"
            button-size="lg">
          
          <div class="p-3">
            <div class="product-card-pro is-selected mb-0 border-warning shadow-none">
              <!-- Header -->
              <div class="card-header-pro d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div class="bg-warning rounded-circle mr-2 d-flex align-items-center justify-content-center" style="width: 32px; height: 32px;">
                    <i class="fa fa-unlock text-white"></i>
                  </div>
                  <h3 class="product-title mb-0" style="white-space: normal;">REABRIR PEDIDO</h3>
                </div>
                <b-button variant="light" size="sm" class="rounded-circle" @click="$refs['modal-reabrir'].hide()">
                  <i class="fa fa-times"></i>
                </b-button>
              </div>

              <div class="px-3 py-2 text-center">
                <p class="text-muted mb-0 font-weight-bold" style="font-size: 0.85rem;">VOCÊ ESTÁ REABRINDO ESTE PEDIDO PARA EDIÇÃO</p>
              </div>

              <!-- Order Details Info Grid -->
              <div class="product-info-grid mt-2">
                <div class="info-item">
                  <span class="info-label">PEDIDO</span>
                  <span class="info-value text-dark font-weight-bold">#{{venda.N_VENDA}}</span>
                </div>
                <div class="info-item">
                   <span class="info-label">VALOR TOTAL</span>
                   <span class="info-value text-success font-weight-bold">{{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</span>
                </div>
              </div>

              <div class="bg-light p-3 mt-3 text-center" style="border-radius: 10px;">
                <span class="d-block text-muted small font-weight-bold text-uppercase mb-1">CLIENTE</span>
                <span class="d-block font-weight-bold text-dark">{{cliente.CODIGO}} - {{cliente.RAZAOSOCIAL}}</span>
              </div>
            </div>
          </div>

          <template #modal-footer="{ cancel }">
            <div class="footer-pro w-100 p-3 bg-white border-top">
               <b-button block variant="warning" class="btn-concluir shadow-sm text-white" @click.stop="reabrir()" style="font-weight: 800;">
                  <i class="fa fa-check-circle mr-2"></i> CONFIRMAR REABERTURA
               </b-button>
               <button class="btn btn-block btn-light mt-2 text-muted font-weight-bold" @click="cancel()" style="border-radius: 10px; height: 48px;">
                  MANTER FECHADO
               </button>
            </div>
          </template>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL CANCELAR
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-cancelar" 
          id="modal-Cancelar" 
          hide-header
          body-class="p-0"
          centered
          :modal-class="['modal-luxury', isDark ? 'pedido-modal-dark' : '']"
          button-size="lg">
        
        <div class="p-3">
          <div class="product-card-pro is-selected mb-0 border-danger shadow-none">
            <!-- Header -->
            <div class="card-header-pro d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <div class="bg-danger rounded-circle mr-2 d-flex align-items-center justify-content-center" style="width: 32px; height: 32px;">
                  <i class="fa fa-times text-white"></i>
                </div>
                <h3 class="product-title mb-0" style="white-space: normal;">CANCELAR PEDIDO</h3>
              </div>
              <b-button variant="light" size="sm" class="rounded-circle" @click="$refs['modal-cancelar'].hide()">
                <i class="fa fa-times"></i>
              </b-button>
            </div>

            <div class="px-3 py-2 text-center">
              <p class="text-muted mb-0 font-weight-bold" style="font-size: 0.85rem;">ATENÇÃO: ESTA AÇÃO IRÁ CANCELAR DEFINITIVAMENTE O PEDIDO</p>
            </div>

            <!-- Order Details Info Grid -->
            <div class="product-info-grid mt-2">
              <div class="info-item">
                <span class="info-label">PEDIDO</span>
                <span class="info-value text-dark font-weight-bold">#{{venda.N_VENDA}}</span>
              </div>
              <div class="info-item">
                 <span class="info-label">VALOR TOTAL</span>
                 <span class="info-value text-danger font-weight-bold">{{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</span>
              </div>
            </div>

            <div class="bg-light p-3 mt-3 text-center" style="border-radius: 10px;">
              <span class="d-block text-muted small font-weight-bold text-uppercase mb-1">CLIENTE</span>
              <span class="d-block font-weight-bold text-dark">{{cliente.CODIGO}} - {{cliente.RAZAOSOCIAL}}</span>
            </div>
          </div>
        </div>

        <template #modal-footer="{ cancel }">
          <div class="footer-pro w-100 p-3 bg-white border-top">
             <b-button block variant="danger" class="btn-concluir shadow-sm" @click="cancelar()" style="font-weight: 800; background: #e55353;">
                <i class="fa fa-trash-o mr-2"></i> CONFIRMAR CANCELAMENTO
             </b-button>
             <button class="btn btn-block btn-light mt-2 text-muted font-weight-bold" @click="cancel()" style="border-radius: 10px; height: 48px;">
                VOLTAR
             </button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VendedorPesquisa from '../../pesquisa/VendedorPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import moment from 'moment'
import { imprimirPedidoEstimado } from './PedidoEstimadoHTML'


export default {
  data () {
    return {
      timerBotao: null,
      intervaloBotao: null,
      isProcessoLongo: false,
      testando: true,
      tabIndex: 0,
      tabIndexItem: 0,
      precoTabelado: false,
      vendaIdEditar: null,
      vlTotalAntes: 0.00,
      pecasEstoqueNegativo: 999999,
      controles: {
        vendaAlteracao: false,
        fechada: false,
        itemAlteracao: false,
        montandoItem: false,
        situacaoCliente : 'Cliente',
        clienteBloqueado : false,
        OP_ICMS_SITUACAO_TRIBUTARIA: null,
        COD_PRO: null,
        campoGerarDocumento: {
          desabilitado: false
        },
        botaoGerarDocumento: {
          value: 'Some value',
          busy: false,
          clicou: false
        }
      },
      cliente: {
        CODIGO: null,
        NOME: null,
        RAZAOSOCIAL: null,
        ID_UF: null,
        FIZ_JUR: null,
        ISENTO_ICMS: null,
        COD_VEND: null,
        VL_CREDITO: 0.00,
        LIMITE_CREDITO: 0.00,
        NOTAS_EM_ABERT0: 0,
        PRAZO: null,
        TIPO_CLI: null,
        GRUPO_ARECEBER_ID: null
      },
      venda: {
        SEQUENCIA                 : null,
        N_VENDA                   : null,
        DT_SAIDA                  : null,
        COD_CLI                   : null,
        DT_PAG                    : null,
        PAG1                      : null,
        PAG2                      : null,
        PAG3                      : null,
        PAG4                      : null,
        PAG5                      : null,
        TIPO                      : null,
        TIPO_VEN                  : null,
        FORMA                     : null,
        COD_VENDEDOR              : null,
        COD_MOTORISTA             : null,
        VL_TOTAL                  : null,
        OBS2                      : null,
        OBS3                      : null,
        LOTE                      : null,
        TIPO_DOCPAG               : null,
        N_DOCPAG                  : null,
        COD_REPRES                : null,
        COD_CONFERENTE            : null,
        TIPO_VENDEDOR             : null,
        ITENS                     : null,
        NENTREGA                  : null,
        PLACA                     : null,
        VL_ENTRADA                : null,
        VL_DESCONTO               : null,
        CFOP                      : null,
        UFENT                     : null,
        TELENT                    : null,
        CONTATOENT                : null,
        BAIRROENT                 : null,
        CIDADEENT                 : null,
        ENDENT                    : null,
        USUARIO                   : null,
        MOT_CANC                  : null,
        NUMNF                     : null,
        SERIENF                   : null,
        UFPLACA                   : null,
        PORCONTA                  : null,
        VOLUMES                   : null,
        PESOLIQUIDO               : null,
        PESOBRUTO                 : null,
        TOTALNF                   : null,
        DT_CANC                   : null,
        DT_ALTERACAO              : null,
        TX_USUARIO_ALTERACAO      : null,
        VL_TOTAL_ANTES_ALTERACAO  : null,
        VL_BASE_CALC_ICMS         : 0.00,
        VL_TOTAL_ICMS             : 0.00,
        VL_BASE_CALC_ST_ICMS      : 0.00,
        VL_TOTAL_ST_ICMS          : 0.00,
        VL_TOTAL_IPI              : 0.00,
        VL_TOTAL_PIS              : 0.00,
        VL_TOTAL_COFINS           : 0.00,
        VL_TOTAL_DESCONTO         : 0.00,
        VL_TOTAL_SEGURO           : 0.00,
        VL_TOTAL_OUTRAS_DESP      : 0.00,
        VL_TOTAL_FRETE            : 0.00,
        NR_PESO_BRUTO             : 0.00,
        VL_TOTAL_PRODUTOS         : 0.00,
        NR_PESO_LIQUIDO           : 0.00,
        VL_TOTAL_NFE              : 0.00,
        QUANT_PEDIDO              : 0.00,
        VL_TOTAL_PREVISTO         : 0.00,
        OP_FORMA_PAGTO            : null,
        TX_USUARIO_CANCELAMENTO   : null,
        NR_PARCELAS               : null,
        COD_TRANSP                : null,
        ORIGEM                    : null,
        DT_PREVISAO_ENTREGA       : null,
        HORA                      : null,
        DT_PEDIDO                 : null,
        DT_SISTEMA_CANCELAMENTO   : null,
        DT_CADASTRO_SISTEMA       : null,
        DT_ALTERACAO_SISTEMA      : null,
        OBSERVACOES               : null,
        SITUACAO                  : null,
        DT_RETORNO                : null,
        NOME_RESPONSAVEL_RETORNO  : null,
        DT_LANCAMENTO_RETORNO     : null,
        OBS_RETORNO               : null,
        USUARIO_RETORNO           : null,
        VL_TOTAL_RETORNO_BKP      : 0.00,
        VL_TOTAL_RETORNO          : 0.00,
        DT_LANCAMENTO_WEB         : null,
        OP_LANCAMENTO_WEB         : null,
        USUARIO_LANCAMENTO_WEB    : null,
        OBS_PEDIDO                : null,
        DT_INICIAR_PAGAMENTO      : moment(new Date()).format('YYYY-MM-DD') 

      },
      itemAlteracao: {
        CONTROLE: null,
        COD_PRO: null,
        CODIGO_NOME_PRODUTO: '',
        PECAS_ESTOQUE: 0,
        PECAS_PEDIDO: 0,
        TX_UNIDADE_COMERCIAL: '',
        VL_UNT: 0.00,
        VL_UNT_MASK: 0.00
      },
      tabelaPreco:{
        selected: null,
        options:[]
      },
      itemExcluir: {
        SEQUENCIA: null,
        CONTROLE: null,
        COD_PRO: null,
        COD_CENTRO: null,
        CODIGO_NOME_PRODUTO: '',
        QUANT: 0.00,
        PECAS_PEDIDO: 0,
        TX_UNIDADE_COMERCIAL: '',
        VL_UNT: 0.00,
        VL_DESCONTO: 0.00,
        VL_TOTAL: 0.00
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false
        }
      },
      modalReabrir: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false,
          permissao : false
        }
      },
      
      parametros: {},
      item: {
        CONTROLE                       : null, 
        SEQUENCIA                      : null, 
        COD_PRO                        : null, 
        EAN                            : null, 
        QUANT                          : null, 
        VL_UNT                         : null, 
        VL_CUSTO                       : null, 
        UND_PECAS                      : null, 
        PECAS                          : null, 
        DT_VENDA                       : null, 
        TIPO_CLI                       : null, 
        MARCA                          : null, 
        TIPO_VEN                       : null, 
        ALTERA                         : null, 
        ITEM                           : null, 
        VL_COMISSAO                    : null, 
        COD_CENTRO                     : null, 
        ICMS                           : null, 
        IPI                            : null, 
        ISS                            : null, 
        IRRF                           : null, 
        ICMSSUBSTITUI                  : null, 
        FORMA                          : null, 
        ID_CFOP                        : null, 
        OP_STATUS_PRECO                : null, 
        VL_TOTAL_BRUTO                 : 0.00, 
        VL_TOTAL_DESCONTO              : null, 
        OP_ICMS_SITUACAO_TRIBUTARIA    : null, 
        OP_ICMS_ORIGEM                 : null, 
        OP_ICMS_MODAL_DETERM_BC        : null, 
        VL_ICMS_PERCENT_REDUC_BC       : '', 
        VL_ICMS_BASE_CALC              : '', 
        VL_ICMS_ALIQUOTA               : '', 
        VL_ICMS                        : '', 
        OP_ICMS_MODAL_DETERM_BC_ST     : null, 
        VL_ICMS_MARGEM_VL_ADIC_ST      : '', 
        VL_ICMS_PERCENT_REDUC_BC_ST    : '', 
        VL_ICMS_BASE_CALC_ST           : '', 
        VL_ICMS_ALIQUOTA_ST            : '', 
        VL_ICMS_ST                     : '', 
        OP_IPI_SITUACAO_TRIBUTARIA     : null, 
        OP_IPI_CLASS_ENQ_CIG_BEB       : null, 
        TX_IPI_CODIGO_ENQUAD_LEGAL     : null, 
        TX_IPI_CNPJ_PRODUTOR           : null, 
        TX_IPI_NUM_SELO_CONTROLE       : null, 
        OP_IPI_TIPO_CALCULO            : null, 
        VL_IPI_BASE_CALC               : '', 
        VL_IPI_ALIQUOTA                : '', 
        VL_IPI_QUANT_TOTAL_UND_PADRAO  : '', 
        VL_IPI_UNIDADE                 : '', 
        VL_IPI                         : '', 
        OP_PIS_SITUACAO_TRIBUTARIA     : null, 
        OP_PIS_TIPO_CALCULO            : null, 
        VL_PIS_BASE_CALC               : '', 
        VL_PIS_ALIQUOTA_PERCENT        : '', 
        VL_PIS_ALIQUOTA_REAIS          : '', 
        VL_PIS_QUANT_VENDIDA           : '', 
        VL_PIS                         : '', 
        OP_PISST_TIPO_CALCULO          : null, 
        VL_PISST_BASE_CALC             : '', 
        VL_PISST_ALIQUOTA_PERCENT      : '', 
        VL_PISST_ALIQUOTA_REAIS        : '', 
        VL_PISST_QUANT_VENDIDA         : '', 
        VL_PISST                       : '', 
        OP_COFINS_SITUACAO_TRIBUTARIA  : null, 
        OP_COFINS_TIPO_CALCULO         : null, 
        VL_COFINS_BASE_CALC            : '', 
        VL_COFINS_ALIQUOTA_PERCENT     : '', 
        VL_COFINS_ALIQUOTA_REAIS       : '', 
        VL_COFINS_QUANT_VENDIDA        : '', 
        VL_COFINS                      : '', 
        OP_COFINSST_TIPO_CALCULO       : null, 
        VL_COFINSST_BASE_CALC          : '', 
        VL_COFINSST_ALIQUOTA_PERCENT   : '', 
        VL_COFINSST_ALIQUOTA_REAIS     : '', 
        VL_COFINSST_QUANT_VENDIDA      : '', 
        VL_COFINSST                    : '', 
        TX_OBSERVACOES                 : null, 
        OP_COMPOE_VALOR_NFE            : null, 
        VL_ICMS_BC_ST_RETIDO_ANT       : '', 
        VL_ICMS_ST_RETIDO_ANT          : '', 
        VL_ICMS_PERC_BC_OPER_PROPRIA   : '', 
        ID_UF_ICMS_ST                  : null, 
        OP_MOTIVO_DESONERACAO          : null, 
        VL_ALIQ_APLICAVEL_CALC_CREDITO : '', 
        VL_CREDITO_ICMS_APROVEITADO    : '', 
        VL_DESCONTO_PERC               : '', 
        TX_NCM                         : null, 
        TX_NOME_PRODUTO                : null, 
        TX_UNIDADE_COMERCIAL           : null, 
        OP_OCORRENCIA_PRECO            : null, 
        VL_DESCONTO                    : null, 
        UNIDADE_COMERCIAL_ID           : null, 
        OP_TRIBUTACAO                  : null, 
        CEST                           : null, 
        QUANT_BKP                      : null, 
        QUANT_RETORNO                  : null, 
        PECAS_BKP                      : null, 
        PECAS_RETORNO                  : null, 
        OBS_RETORNO                    : null,
        OBS_PEDIDO                     : null,
        DT_INICIAR_PAGAMENTO           : moment(new Date()).format('YYYY-MM-DD') 
      },
      pesagem: {
        peso: 0.00,
        manual: false,
        fields: [
          { key: 'ID', stickyColumn: true, isRowHeader: true, variant: 'primary' },
          {key: 'COL1',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL2',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL3',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL4',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL5',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL6',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL7',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL8',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL9',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {key: 'COL10',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
        ],
        items:[]
      },
      tipoVenda: [
        { value: 'VENDA', text: '1 - Romaneio de Vendas' },
        { value: 'PEDIDO', text: '2 - Pedido de Vendas' },
        { value: 'TROCA', text: '3 - Troca de Mercadoria' },
      ],
      tipoPagamento: [
        { value: 'V', text: 'A VISTA' },
        { value: 'P', text: 'A PRAZO'}
      ],
      tipoContatoOptions: [
        { value: '0', text: 'Telefone' },
        { value: '1', text: 'Visita' },
        { value: '2', text: 'Internet' },
      ],
      parcelasVezes: [],
      dias:[],
      produtos: {
        currentPage: 1,
        perPage: 20,
        totalRows: 1,
        items: [],
        campos: [
          {
            key: "PRODUTO_ID",
            label: ' ',
            thClass: 'd-none',
            tdClass: 'p-0 border-0'
          }
        ]
      },
      estoqueCriticaModal: {
        visivel: false,
        mensagem: '',
        itens: []
      },
      estoqueProduto: {
        options: [],
        QUANT: 0.00,
        PECAS: 0,
      },
      tabelaItens: {
        fields: [
          {
            key: "item",
            label: '',
            tdClass: 'p-0 border-0'
          }
        ],
        items: []
      },
      filter: '',
      apenasLancados: false,
      filterOn: [],
      ignorados: [],
      produto: {
        id: null,
        quantidade : 0.00,
        pecas : 0,
        valor: 0.00,
        total: 0.00
      },
      modalItem:{
        overlayBaixando: false,
        icms: {
          opTipoSituacaoTributariaSimples: [
            { value : '00', text : 'ICMS 00 -Tributada Integralmente'},
            { value : '10', text : 'ICMS 10 - Tributada com cobrança do ICMS por Substituição Tributária'},
            { value : '20', text : 'ICMS 20 - Com redução na base de cálculo'},
            { value : '30', text : 'ICMS 30 - Isenta ou não tributada com cobrança do ICMS por substituição tributária'},
            { value : '40', text : 'ICMS 40 - Isenta'},
            { value : '41', text : 'ICMS 41 - Não tributada'},
            { value : '50', text : 'ICMS 50 - Suspensão'},
            { value : '51', text : 'ICMS 51 - Diferimento'},
            { value : '60', text : 'ICMS 60 - Cobrado anteriormente por substiruição tributária'},
            { value : '70', text : 'ICMS 70 - Com redução da base de cálculo e cobrança do ICMS por substituição tributária'},
            { value : '90', text : 'ICMS 90 - Outras'},
          ],
          opTipoSituacaoTributariaNormal: [
            { value: '101', text: 'ICMS 101 - Tributada com permissão de crédito'},
            { value: '102', text: 'ICMS 102 - Trib utada sem permissão de crédito'},
            { value: '103', text: 'ICMS 103 - Isenção do ICMS para faixa de receita bruta'},
            { value: '201', text: 'ICMS 201 - Tributada com permissão de crédito e com cobrança do ICMS por ST'},
            { value: '202', text: 'ICMS 202 - Tributada sem permissão de crédito e com cobrança do ICMS por ST'},
            { value: '203', text: 'ICMS 203 - Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por ST'},
            { value: '300', text: 'ICMS 300 - Imune'},
            { value: '400', text: 'ICMS 400 - Não tributada'},
            { value: '500', text: 'ICMS 500 - ICMS cobrado anteriormente por ST ou por antecipação'},
            { value: '900', text: 'ICMS 900 - Outros'}
          ],
          opOrigemMercadoria: [
            { value: '0', text: 'Nacional'},
            { value: '1', text: 'Extrangeira - Importação Direta'},
            { value: '2', text: 'Extrangeira - Adquirida no Mercado Interno'},
          ],
          opModalidade: [
            { value: '0', text: 'Margem Valor Agregado'},
            { value: '1', text: 'Pauta Valor'},
            { value: '2', text: 'Preço tabelado Max. Valor'},
            { value: '3', text: 'Valor da Operação'},
          ],
          opMotivoDesoneracao: [
            { value: '', text: ''},
            { value: '1', text: 'Taxi'},
            { value: '2', text: 'Deficiente Fisico'},
            { value: '3', text: 'Produto Agropecuário'},
            { value: '4', text: 'Frotista/Locadora'},
            { value: '5', text: 'Diplomata/Consultor'},
            { value: '9', text: 'Outros'},
            { value: '6', text: 'Utilit. e Motoc. da Amazônia Ocidental'},
            { value: '7', text: 'SUFRAMA'},
          ],
          opModalidadeST: [
            { value: '0', text: 'Preço Tabelado ou Máximo Sugerido'},
            { value: '1', text: 'Lista Negativa (Valor)'},
            { value: '2', text: 'Lista Positiva (valor)'},
            { value: '3', text: 'Lista Neutra (valor)'},
            { value: '4', text: 'Margem Valor Agregado (%)'},
            { value: '5', text: 'Pauta (valor)'},
          ],
        },
        pis:{
          opTipoSituacaoTributaria: [
            { value: '01', text : 'PIS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text : 'PIS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text : 'PIS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text : 'PIS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text : 'PIS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text : 'PIS 07 - Operação Isenta da Contribuição'},
            { value: '08', text : 'PIS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text : 'PIS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text : 'PIS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        cofins:{
          opTipoSituacaoTributaria: [
            { value: '01', text: 'COFINS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text: 'COFINS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text: 'COFINS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text: 'COFINS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text: 'COFINS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text: 'COFINS 07 - Operação Isenta da Contribuição'},
            { value: '08', text: 'COFINS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text: 'COFINS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text: 'COFINS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        }
      },   
      icms: {
        habilitado: {
          comboOP_ICMS_ORIGEM              : true, // Sempre Visivel
          
          //Grupo ICMS Normal
          comboOP_ICMS_MODAL_DETERM_BC     : false,
          edVL_ICMS_PERCENT_REDUC_BC       : false,
          edVL_ICMS_BASE_CALC              : false,
          edVL_ICMS_ALIQUOTA               : false,
          edVL_ICMS_PERC_BC_OPER_PROPRIA   : false,
          edVL_ICMS                        : false,

          comboOP_MOTIVO_DESONERACAO       : false,

          //Grupo ICMS Normal ST
          comboOP_ICMS_MODAL_DETERM_BC_ST  : false,
          edVL_ICMS_PERCENT_REDUC_BC_ST    : false,
          edVL_ICMS_MARGEM_VL_ADIC_ST      : false,
          edVL_ICMS_BASE_CALC_ST           : false,
          edVL_ICMS_ALIQUOTA_ST            : false,
          edVL_ICMS_ST                     : false,
          comboID_UF_ICMS_ST               : false,

          //Grupo ICMS Simples
          edVL_ALIQ_APLICAVEL_CALC_CREDITO : false,
          edVL_CREDITO_ICMS_APROVEITADO    : false,

          //Grupo ICMS Simples ST
          edVL_ICMS_BC_ST_RETIDO_ANT       : false,
          edVL_ICMS_ST_RETIDO_ANT          : false,

          
        }
      },
      criarDataSegura(data) {
        if (!data) return null

        if (typeof data === 'string') {
          const [ano, mes, dia] = data.split('-').map(Number)
          return new Date(ano, mes - 1, dia)
        }

        if (data instanceof Date) {
          return new Date(data.getFullYear(), data.getMonth(), data.getDate())
        }

        return null
      }

    }
    
  },
  components: {
    VendedorPesquisa,
    ClientePesquisa,
    FuncionarioPesquisa,
    ProdutoPesquisa,
    VueAutonumeric
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    resumoSelecaoModal() {
      let total = 0
      let quant = 0
      if (this.produtos && this.produtos.items) {
        this.produtos.items.forEach(it => {
          if (it.PECAS_PEDIDO > 0) {
            quant += Number(it.PECAS_PEDIDO || 0)
            total += (Number(it.PECAS_PEDIDO || 0) * Number(it.VL_UNT || 0))
          }
        })
      }
      return { total, quant }
    },
    diasSugestaoOrdenados() {
    let diasPadrao = [3, 4, 5, 6, 7, 8, 9, 10, 14, 15, 20, 30]
    let diasCliente = this.diasIniciarPagamentoCliente

    if (diasCliente != null && !diasPadrao.includes(diasCliente)) {
      diasPadrao.push(diasCliente)
    }

    return diasPadrao.sort((a, b) => a - b) // ordenar crescente
  },

  diasIniciarPagamentoCliente() {
    if (this.venda.PAG1 != null && !isNaN(this.venda.PAG1)) {
      return parseInt(this.venda.PAG1)
    }
    return null
  },

  diasSelecionados() {
  if (!this.venda.DT_PEDIDO || !this.venda.DT_INICIAR_PAGAMENTO) {
    return null
  }

  const dataPedido = this.criarDataSegura(this.venda.DT_PEDIDO)
  const dataInicio = this.criarDataSegura(this.venda.DT_INICIAR_PAGAMENTO)

  const diferencaMs = dataInicio.getTime() - dataPedido.getTime()
  const diferencaDias = Math.round(diferencaMs / (1000 * 60 * 60 * 24))

  return diferencaDias
}

,
//$####################################### FUNCIONADNO TUDO
textoInicioPagamento() {
  const dtPedido = this.criarDataSegura(this.venda.DT_PEDIDO)
  const dtIniciar = this.criarDataSegura(this.venda.DT_INICIAR_PAGAMENTO)

  if (dtPedido && dtIniciar) {
    const diffTime = dtIniciar.getTime() - dtPedido.getTime()
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays === 0) {
      return 'Início do pagto - Hoje'
    } else if (diffDays === 1) {
      return 'Início do pagto (1 dia após o pedido)'
    } else {
      return `Início do pagto (${diffDays} dias após o pedido)`
    }
  }

  return 'Início do pagamento'
},
    produtoTotal: {
       get() {
        return 0.00
       },
       set() {

       }
    },
    habilitaBotaoProdutos() {
      //return ((!this.controles.fechada) && (!this.clienteBloqueado))
      
      return (this.controles.fechada == false) && (this.controles.clienteBloqueado == false)
    },
    habilitaBotaoExcluir() {
      const seq = this.venda.SEQUENCIA
      const sit = this.venda.SITUACAO
      const habilita = (seq > 0 && sit == '2')
      
      return habilita
    },

    valN_VENDA(){
      return ((this.venda.N_VENDA ) && (this.venda.N_VENDA > 0)) ? true : false
    },
    valCOD_CLI(){
      return ((this.venda.COD_CLI ) && (this.venda.COD_CLI > 0)) ? true : false
    },
    valCOD_VENDEDOR(){
      return ((this.venda.COD_VENDEDOR ) && (this.venda.COD_VENDEDOR > 0)) ? true : false
    },
    valCOD_CONFERENTE(){
      return ((this.venda.COD_CONFERENTE ) && (this.venda.COD_CONFERENTE > 0)) ? true : false
    },
    valCOD_MOTORISTA(){
      return ((this.venda.COD_MOTORISTA ) && (this.venda.COD_MOTORISTA > 0)) ? true : false
    },
    valOP_FORMA_PAGTO() {
      return ((this.venda.OP_FORMA_PAGTO ) && (this.venda.OP_FORMA_PAGTO != '')) ? true : false
    },
    valPAG1() {
      return this.venda.PAG1 == null ? false : true
    },
    valCOD_PRO(){
      return ((this.item.COD_PRO ) && (this.item.COD_PRO > 0)) ? true : false
    },
    valQUANT(){
      return ((this.item.QUANT ) && (this.item.QUANT > 0)) ? true : false
    },
    valOBS3() {
      return ((this.venda.OBS3 ) && (this.venda.OBS3 != '')) ? true : false
    },
    totalVenda() {
      if (this.venda.VL_TOTAL_PREVISTO && this.venda.VL_TOTAL_PREVISTO > 0) {
        return this.venda.VL_TOTAL_PREVISTO
      }
      if (this.tabelaItens.items && Array.isArray(this.tabelaItens.items)) {
        return this.tabelaItens.items.reduce((soma, item) => soma + this.totalPrevistoItem(item), 0)
      }
      return this.venda.VL_TOTAL_NFE && this.venda.VL_TOTAL_NFE > 0 ? this.venda.VL_TOTAL_NFE : 0.00
    },
    limiteCredito() {
      return this.cliente.LIMITE_CREDITO && this.cliente.LIMITE_CREDITO > 0 ? this.cliente.LIMITE_CREDITO : 0.00
    },
    totalBruto() {
      return this.item.VL_TOTAL_BRUTO && this.item.VL_TOTAL_BRUTO > 0 ? this.item.VL_TOTAL_BRUTO : 0.00
    },
    
    totalQuant(){
      let soma = 0.00
      if (this.tabelaItens.items && Array.isArray(this.tabelaItens.items)){
          this.tabelaItens.items.forEach(it => {
            soma += it.QUANT || 0
          })
      }
      return soma
    },
    totalPecas(){
      let soma = 0
      if (this.tabelaItens.items && Array.isArray(this.tabelaItens.items)){
          this.tabelaItens.items.forEach(it => {
            soma += Number(it.PECAS_PEDIDO) || 0
          })
      }
      return soma
    },
    totalItensLancados(){
      let count = 0
      if (this.tabelaItens.items){
          this.tabelaItens.items.forEach(it => {
            let p = Number(it.PECAS_PEDIDO) || 0
            let v = it.VL_UNT
            if (typeof v === 'string') {
                v = v.replace(/\./g, '').replace(',', '.')
            }
            v = Number(v) || 0
            if (p > 0 || v > 0) {
              count++
            }
          })
      }
      return count
    },
    totalVolumes(){
        return this.tabelaItens.items.length?? 0
    },
    filteredProducts() {
      if (!this.produtos.items) return []
      let filtered = this.produtos.items
      if (this.apenasLancados) {
        filtered = filtered.filter(it => it.PECAS_PEDIDO > 0)
      }
      return filtered
    },
    tamanhocampoPagina () {
      if (this.venda.PAGINA) {
        return this.venda.PAGINA.length > 2 ? null : false
      }
      return false
    }
  },
  methods: {
    numero(valor) {
      if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0
      if (valor === null || typeof valor === 'undefined') return 0
      const texto = String(valor).replace(/[^\d,.-]/g, '')
      if (texto.indexOf(',') >= 0 && texto.indexOf('.') >= 0) return Number(texto.replace(/\./g, '').replace(',', '.')) || 0
      if (texto.indexOf(',') >= 0) return Number(texto.replace(',', '.')) || 0
      return Number(texto) || 0
    },
    formatarMoeda(valor) {
      return this.numero(valor).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    },
    formatarPeso(valor) {
      return this.numero(valor).toLocaleString('pt-BR', {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
      })
    },
    mediaPrevistaProduto(item) {
      if (!item) return 0
      if (String(item.OP_PESO_FIXO || '').trim() === '1') {
        return this.numero(item.PESO_LIQUIDO)
      }
      const mediaEstoque = this.numero(item.MEDIA_ESTOQUE)
      if (mediaEstoque > 0) return mediaEstoque
      const pecasEstoque = this.numero(item.PECAS)
      return pecasEstoque > 0 ? this.numero(item.QUANT) / pecasEstoque : 0
    },
    quantidadePrevistaProduto(item) {
      return this.numero(item && item.PECAS_PEDIDO) * this.mediaPrevistaProduto(item)
    },
    totalPrevistoProduto(item) {
      return this.quantidadePrevistaProduto(item) * this.numero(item && item.VL_UNT)
    },
    totalPrevistoItem(item) {
      const totalPrevisto = this.numero(item.VL_TOTAL_PREVISTO)
      if (totalPrevisto > 0) return totalPrevisto
      return this.numero(item.QUANT_PEDIDO) * this.numero(item.VL_UNT)
    },
    async atualizarVendaAtual() {
      const vendaResponse = await this.$http.get(`/api/protected/vendapedido/getById/${this.venda.SEQUENCIA}`)
      this.venda = vendaResponse.data && vendaResponse.data[0] ? vendaResponse.data[0] : this.venda
      this.venda.DT_PEDIDO = this.venda.DT_PEDIDO ? Tools.formatarDataParaInput(this.venda.DT_PEDIDO) : null
      this.venda.DT_SAIDA = this.venda.DT_SAIDA ? Tools.formatarDataParaInput(this.venda.DT_SAIDA) : null
      this.venda.DT_INICIAR_PAGAMENTO = this.venda.DT_INICIAR_PAGAMENTO ? Tools.formatarDataParaInput(this.venda.DT_INICIAR_PAGAMENTO) : null
    },
    async imprimirPedidoEstimado() {
      await imprimirPedidoEstimado(this.$http, this.venda.SEQUENCIA, {
        venda: this.venda,
        itens: this.tabelaItens.items
      })
    },
    voltar() {
     this.$router.push(`/dashboard/vendedor`)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.produtos.totalRows = filteredItems.length
      this.produtos.currentPage = 1
    },
    limparCriticaEstoqueModal() {
      this.estoqueCriticaModal.visivel = false
      this.estoqueCriticaModal.mensagem = ''
      this.estoqueCriticaModal.itens = []

      if (this.produtos && Array.isArray(this.produtos.items)) {
        this.produtos.items.forEach(item => {
          this.$set(item, '_estoqueCritico', false)
        })
      }
    },
    aplicarCriticaEstoqueModal(payload) {
      const itensCritica = Array.isArray(payload && payload.itens) ? payload.itens : []
      if (!itensCritica.length) return

      this.limparCriticaEstoqueModal()
      this.apenasLancados = false
      this.estoqueCriticaModal.visivel = true
      this.estoqueCriticaModal.mensagem = payload && payload.mensagem
        ? payload.mensagem
        : 'O saldo de alguns produtos mudou enquanto o modal estava aberto.'
      this.estoqueCriticaModal.itens = itensCritica

      itensCritica.forEach(itemCritica => {
        const itemModal = this.produtos.items.find(item => item.PRODUTO_ID === itemCritica.PRODUTO_ID)
        if (!itemModal) return

        const pecasDisponiveis = Number(itemCritica.PECAS_DISPONIVEIS_ATUAL || 0)
        const pecasAjustadas = Number(itemCritica.PECAS_PEDIDO_AJUSTADO || 0)

        this.$set(itemModal, 'PECAS', pecasDisponiveis)
        this.$set(itemModal, 'PECAS_PEDIDO', pecasAjustadas)
        this.$set(itemModal, '_estoqueCritico', true)
      })

      this.produtos.totalRows = this.filteredProducts.length
      this.produtos.currentPage = 1
    },
    async abrirModalAlterarProduto(item) {
      if (this.venda.SITUACAO != '2') return

      if (item.CONTROLE && item.CONTROLE > 0) {

          this.$store.commit('controle/setAguardando', true)
          if ( await this.carregarAlteracaoProduto(item.CONTROLE) == true)  {
            this.$refs['modal-alterar-item'].show()
            this.$store.commit('controle/setAguardando', false)
          } else {
            this.$store.commit('controle/setAguardando', false)
            this.$bvToast.toast(`Ocorreu um problema ao executar a operação!! ${error}` , {
                  title: 'Erro',
                  autoHideDelay: 5000,
                  variant: 'danger',
                  appendToast: true
                })
            return
          }
      } else {

      }   
      
    }
    ,
    async abrirModalListaDeProdutos() {
      if (this.venda.COD_CLI === null) {
          
        this.$root.$bvToast.toast(`É necessario informar o CLIENTE!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
        return
      }
      //NOVA VENDA
      if ((typeof this.venda.SEQUENCIA === 'undefined') || (this.venda.SEQUENCIA === null) || (this.venda.SEQUENCIA === '')) {
          this.$store.commit('controle/setAguardando', true)
          if (await this.gravarVendaSimples() == true) {
            
            if ( await this.carregarListaProdutos() == true)  {
              this.$refs['modal-lista-produtos'].show()
              this.$store.commit('controle/setAguardando', false)
            } else {
              this.$store.commit('controle/setAguardando', false)
              this.$bvToast.toast(`Ocorreu um problema ao executar a operação!! ${error}` , {
                    title: 'Erro',
                    autoHideDelay: 5000,
                    variant: 'danger',
                    appendToast: true
                  })
              return
            }
          } else {
            this.$store.commit('controle/setAguardando', false)
            return
          }
      } else { //ALTERACAO DA VENDA
        this.$store.commit('controle/setAguardando', true)
          if (await this.alterarVendaSimples() == true) {
            if ( await this.carregarListaProdutos() == true)  {
              this.$refs['modal-lista-produtos'].show()
              this.$store.commit('controle/setAguardando', false)
            } else {
              this.$store.commit('controle/setAguardando', false)
              this.$bvToast.toast(`Ocorreu um problema ao executar a operação!! ${error}` , {
                    title: 'Erro',
                    autoHideDelay: 5000,
                    variant: 'danger',
                    appendToast: true
                  })
              return
            }
          } else {
            this.$store.commit('controle/setAguardando', false)
            return
          }
      }
    },

    async gravarVendaSimples() {
      return new Promise((resolve, reject) => {
        
        this.$http.post(`/api/protected/vendapedido/postOnly`, this.venda)
        .then(response => {
          this.venda = response.data
          this.venda.DT_SAIDA = this.venda.DT_SAIDA ? Tools.formatarDataParaInput(this.venda.DT_SAIDA) : null
          this.venda.DT_PEDIDO = Tools.formatarDataParaInput(this.venda.DT_PEDIDO)
          this.venda.DT_INICIAR_PAGAMENTO = Tools.formatarDataParaInput(this.venda.DT_INICIAR_PAGAMENTO)

          this.item.SEQUENCIA      = this.venda.SEQUENCIA
          this.item.OP_TRIBUTACAO  = '0'
          this.item.COD_CENTRO     = this.parametros.COD_CENTROESTOQUE
          this.item.ID_CFOP        = this.parametros.COD_CFOPVEN
          this.item.SITUACAO       = '2'
          
          
          // this.controles.itemAlteracao = false
          resolve(true)
        })
        .catch(erro => {
          this.toastCount++
          this.$root.$bvToast.toast(`Falha ao cadastrar a venda!! ${erro}`, {
            title: 'Erro',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
          this.$store.commit('controle/setAguardando', false)
          reject(false)
        })
      })
    },
    async alterarVendaSimples() {
      return new Promise((resolve, reject) => {
        
        this.$http.post(`/api/protected/vendapedido/edit`, this.venda)
        .then(response => {
          //this.venda = 
          // this.venda.DT_SAIDA = new Date(this.response.data.DT_SAIDA).toJSON().slice(0, 10)
          // this.controles.itemAlteracao = false
          resolve(true)
        })
        .catch(erro => {
          this.toastCount++
          this.$root.$bvToast.toast(`Ocorreu um problema ao fazer a atualização do Pedido!! ${erro}`, {
            title: 'Erro',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
          reject(false)
        })
      })
    },
    variantEstoquePecas (value) {
      let $variant = 'text-red'
      if ((value > 0) && (value < this.pecasEstoqueNegativo)) {
        $variant = 'text-blue'
      } 
      return $variant
    },
    /* ****************************  ITEM *****************/
    abrirModalItemNovo () {
      this.tabIndexItem = 0
      this.controles.montandoItem = false

      // A VENDA JÁ FOI INICIADA
      if (this.venda.SEQUENCIA !== null) {
        this.criarItem(false, {})
        this.limparAliquotasICMS()
        this.pesagem.items = []
        this.pesagem.manual = false
        this.atualizarTabelaPesagem()
        this.item.SEQUENCIA      = this.venda.SEQUENCIA
        this.item.OP_TRIBUTACAO  = '0'
        this.item.COD_CENTRO     = this.parametros.COD_CENTROESTOQUE
        this.item.ID_CFOP        = this.parametros.COD_CFOPVEN
        
        this.controles.OP_ICMS_SITUACAO_TRIBUTARIA = null
        this.controles.COD_PRO = null
        this.controles.itemAlteracao = false
        
        this.$refs['modal-item'].show()
        
      } // NAO EXISTE ID NA VENDA E PRECISA GRAVAR ANTES DE ABRIR O FORM DE PRODUTO
      else {
        if (this.venda.COD_CLI === null) {
          
          this.$root.$bvToast.toast(`É necessario informar o CLIENTE!!`, {
              title: 'Aviso',
              autoHideDelay: 3000,
              variant: 'danger',
              appendToast: true
            })
          return
        } 
        

        this.$http.get('/api/protected/tools/incrementarGenerator?generator=RCVEN000_SEQUENCIA_GEN')
        .then(response => {
          let vendaAux = JSON.parse(JSON.stringify(this.venda))
          vendaAux.SEQUENCIA = response.data
        
          this.$http.post(`/api/protected/vendapedido/post`, vendaAux)
          .then(response => {
            this.venda = response.data
            //this.venda.DT_SAIDA = new Date(this.venda.DT_SAIDA).toJSON().slice(0, 10)
            this.venda.DT_INICIAR_PAGAMENTO = Tools.formatarDataParaInput(this.venda.DT_INICIAR_PAGAMENTO)
            this.$store.commit('controle/setAguardando', false)
            
            this.toastCount++
            this.$root.$bvToast.toast(`Venda INICIADA com Sucesso!!!`, {
              title: 'Aviso',
              autoHideDelay: 3000,
              variant: 'success',
              appendToast: true
            })

            this.criarItem(false, {})
            this.limparAliquotasICMS()
            this.pesagem.items = []
            this.pesagem.manual = false
            this.atualizarTabelaPesagem()
            this.item.SEQUENCIA      = this.venda.SEQUENCIA
            this.item.OP_TRIBUTACAO  = '0'
            this.item.COD_CENTRO     = this.parametros.COD_CENTROESTOQUE
            this.item.ID_CFOP        = this.parametros.COD_CFOPVEN
            
            this.controles.OP_ICMS_SITUACAO_TRIBUTARIA = null
            this.controles.COD_PRO = null

            this.$store.commit('controle/setAguardando', false)
            // this.controles.itemAlteracao = false
            this.$refs['modal-item'].show()
          })
          .catch(erro => {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha ao cadastrar a venda!! ${erro}`, {
              title: 'Erro',
              autoHideDelay: 3000,
              variant: 'danger',
              appendToast: true
            })
            this.$store.commit('controle/setAguardando', false)
          })
        })
        .catch(erro => {
          this.toastCount++
          this.$root.$bvToast.toast(`Falha ao cadastrar a venda!! ${erro}`, {
            title: 'Erro',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
          this.$store.commit('controle/setAguardando', false)
        })
      }
    },
    abrirModalItemEditar (item) {
      if (this.controles.fechada) {
        return
      }
      this.tabIndexItem = 0

      if (item[0] && item[0].CONTROLE) {
        this.$store.commit('controle/setAguardando', true)
        this.controles.itemAlteracao = true
        this.$http.get(`/api/protected/vendapedido/item/getById/${item[0].CONTROLE}`)
        .then(result => {
          this.controles.montandoItem = true
          this.criarItem(true, result.data[0])
        })
        .then(() => {
          this.controles.montandoItem = false
        })
        .then(() => {
          this.gerarPesagemAlteracao()
        })
        .then(() => {
          
          this.$refs['modal-item'].show()
          this.$store.commit('controle/setAguardando', false)
        })
        .catch(err => {
          this.controles.montandoItem = false
          this.$store.commit('controle/setAguardando', false)
          this.$root.$bvToast.toast(`Falha ao criar o Item!! ${err}`, {
            title: 'Erro',
            autoHideDelay: 6000,
            variant: 'danger',
            appendToast: true
          })

        })

        
      }
    },
    async excluirItem(){
      try{
        this.$store.commit('controle/setAguardando', true)
        this.venda.SITUACAO = '2' //LANCANDO
        let pacote = {
          venda: this.venda,
          item: this.itemExcluir,
          login: window.localStorage.getItem('login')
        }
        try {
          await this.$http.post(`/api/protected/vendapedido/item/delete`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return 
        }
          
        let itensResponse = await this.$http.get('/api/protected/vendapedido/item/getListagemByVenda/'+this.venda.SEQUENCIA)
        this.tabelaItens.items = itensResponse?.data?? null
        if (this.tabelaItens.items) {
          for (let i = 0; i < this.tabelaItens.items.length; i++) {
            this.tabelaItens.items[i].VL_UNT = this.tabelaItens.items[i].VL_UNT?.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2})
          }  
        }

        let vendaResponse = await this.$http.get(`/api/protected/vendapedido/getById/${this.venda.SEQUENCIA}`)
        this.venda = vendaResponse.data?.[0]
        if (!this.venda) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'O Pedido não foi processado corretamente. Volte a tela principal!' )
          return 
        }

        this.venda.DT_PEDIDO            = this.venda.DT_PEDIDO ? Tools.formatarDataParaInput(this.venda.DT_PEDIDO) : null
        this.venda.DT_SAIDA             = this.venda.DT_SAIDA ? Tools.formatarDataParaInput(this.venda.DT_SAIDA) : null
        this.venda.DT_INICIAR_PAGAMENTO = this.venda.DT_INICIAR_PAGAMENTO ? Tools.formatarDataParaInput(this.venda.DT_INICIAR_PAGAMENTO) : null
           
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-excluir-item'].hide()
      }
      
    },
    async alterarItem() {
      this.$store.commit('controle/setAguardando', true)
      try {
        // Tenta gravar a alteração do item
        await this.$http.post(`/api/protected/vendapedido/item/editPecasPedido/${this.itemAlteracao.CONTROLE}/${this.itemAlteracao.PECAS_PEDIDO}`)

        // Tenta carregar a lista de itens
        const response = await this.$http.get(`/api/protected/vendapedido/item/getListagemByVenda/${this.venda.SEQUENCIA}`)

        this.tabelaItens.items = []
        if (response.data && response.data.length) {
          response.data.forEach(item => {
            if (item.VL_UNT && item.VL_UNT > 0) {
              item.VL_UNT = item.VL_UNT.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 })
            }
            this.tabelaItens.items.push(item)
          })
        }

        await this.atualizarVendaAtual()

      } catch (err) {
        this.handleError(err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-alterar-item'].hide()
      }
    },

    handleError(err) {
      if (err.response && err.response.status === 400) {
        this.toastCount++;
        this.$root.$bvToast.toast(`Atenção: ${err.response.data}`, {
          title: 'Atenção',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true,
        })
      } else {
        this.$root.$bvToast.toast(`Não foi possível executar a operação!! ${err}`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true,
        })
      }
    },
    gerarComboParcelas() {
      this.parcelasVezes = [] 
      for (let i = 0; i < 48; i++) {
        this.parcelasVezes.push({ value: (i+1).toString() , text: (i+1)+'X' })
      }
    },
    gerarDias() {
      this.dias = [] 
      this.dias.push({ value: '0' , text: ' Nenhum' })
      for (let i = 0; i < 60; i++) {
        this.dias.push({ value: (i+1).toString() , text: (i+1)+' dias' })
      }
      this.dias.push({ value: '120' , text: ' 120 dias' })
      this.dias.push({ value: '150' , text: ' 150 dias' })
      this.dias.push({ value: '180' , text: ' 180 dias' })
      this.dias.push({ value: '210' , text: ' 210 dias' })
      this.dias.push({ value: '240' , text: ' 240 dias' })
      this.dias.push({ value: '270' , text: ' 270 dias' })
      this.dias.push({ value: '300' , text: ' 300 dias' })
      this.dias.push({ value: '360' , text: ' 360 dias' })
    }, 
    async finalizarVenda(){

      if (this.venda.OP_FORMA_PAGTO === 'V' ) {
        this.venda.NR_PARCELAS = null
        this.venda.PAG1 = null
        this.venda.DT_INICIAR_PAGAMENTO = null
      }

      if (!this.avisosVenda()) {
        return
      } 

      if (this.vendaIdEditar != null)  {
        this.venda.DT_ALTERACAO = Tools.getDataAtual()
        this.venda.TX_USUARIO_ALTERACAO = ''
        this.venda.DT_ALTERACAO_SISTEMA = Tools.getDataAtual()
        if (this.venda.FORMA === 'VENDA' ) {
            this.venda.TIPO_VEN = '0'
        }
      }
      
     let itens = ''
      
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            itens += it.NOME_PRODUTO.substring(0,4)
          })
        } 
      }

      this.venda.ITENS = itens.substring(0, 49)
      this.venda.USUARIO_PEDIDO = window.localStorage.getItem('login')
      this.venda.USUARIO_LANCAMENTO_WEB = window.localStorage.getItem('login')
      
      let pacote = {
        venda: this.venda,
        itens: this.tabelaItens.items
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.post(`/api/protected/vendapedido/finalizar`, pacote)
          this.$router.push('/dashboard/vendedor')
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        /*
        try {
          await this.$http.get(`/api/protected/relatorios/relvendapedido?id=${this.venda.SEQUENCIA}` , {responseType: 'arraybuffer'})
          let numeroPedido = this.venda.N_VENDA
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `relPedido.pdf`) 
          link.download = 'relPedido.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = `${numeroPedido} - Pedido`
            }, 3000);
          }
          this.$router.go(-1)
        } catch(err) {
          this.$router.go(-1)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório indisponível' )
          return
        }
          */
      } finally {
        
        this.$store.commit('controle/setAguardando', false)
        
      }

    },
    
    abrirModalExcluirItem(item) { 
      this.$store.commit('controle/setAguardando', true)
      this.itemExcluir.CODIGO_NOME_PRODUTO = item.CODIGO_NOME_PRODUTO
      this.itemExcluir.CONTROLE = item.CONTROLE
      

      this.$http.get('/api/protected/vendapedido/item/getById/'+this.itemExcluir.CONTROLE)
      
      .then(result => {
         this.itemExcluir.SEQUENCIA = result.data[0].SEQUENCIA
         this.itemExcluir.CONTROLE = result.data[0].CONTROLE
         this.itemExcluir.COD_PRO = result.data[0].PRODUTO_ID
         this.itemExcluir.COD_CENTRO = result.data[0].COD_CENTRO
         this.itemExcluir.QUANT = result.data[0].QUANT
         this.itemExcluir.PECAS_PEDIDO = result.data[0].PECAS_PEDIDO
         this.itemExcluir.TX_UNIDADE_COMERCIAL = result.data[0].UNIDADE_COMERCIAL_ID
         this.itemExcluir.VL_UNT = result.data[0].VL_UNT
         this.itemExcluir.VL_DESCONTO = result.data[0].VL_DESCONTO
         this.itemExcluir.VL_TOTAL_BRUTO = result.data[0].VL_TOTAL_BRUTO
         
         this.itemExcluir.QUANT_MASK          = result.data[0].QUANT ? result.data[0].QUANT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
         this.itemExcluir.VL_UNT_MASK         = result.data[0].VL_UNT ? result.data[0].VL_UNT.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
         this.itemExcluir.VL_DESCONTO_MASK    = result.data[0].VL_DESCONTO ? result.data[0].VL_DESCONTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
         this.itemExcluir.VL_TOTAL_BRUTO_MASK = result.data[0].VL_TOTAL_BRUTO ? result.data[0].VL_TOTAL_BRUTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
         
         this.$store.commit('controle/setAguardando', false)
         this.$refs['modal-excluir-item'].show()
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++
        this.$root.$bvToast.toast(`O sistema não localizou o item !! ${erro}`, {
          title: 'Erro',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
       
      })
    },
    async reabrir() {
      
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post(`/api/protected/vendapedido/reabrir`, {id: this.venda.SEQUENCIA})

        const {data} = await this.$http.get(`/api/protected/vendapedido/getById/${this.venda.SEQUENCIA}`)

        data[0].DT_SAIDA = data[0].DT_SAIDA ? Tools.formatarDataParaInput(data[0].DT_SAIDA) : null
        data[0].DT_PEDIDO = Tools.formatarDataParaInput(data[0].DT_PEDIDO)
        data[0].DT_INICIAR_PAGAMENTO  = data[0].DT_INICIAR_PAGAMENTO ? Tools.formatarDataParaInput(Tools.getDataAtual()) : null
        
        this.venda = data[0]

        this.controles.fechada = false
      
        this.$refs['modal-reabrir'].hide()

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'O Pedido foi reaberto com Sucesso!!!!' )
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async cancelar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        const body = {
          id: this.venda.SEQUENCIA,
          login: window.localStorage.getItem('login'),
          motivo: null
        }
        
        let vendaResponse = null
        try {
          vendaResponse = await this.$http.post(`/api/protected/vendapedido/cancelar`, body)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return 
        }
      
        this.controles.fechada = false
        this.$refs['modal-cancelar'].hide()

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'O Pedido foi cancelado com Sucesso!' )
        this.voltar()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    abrirModalReabrir(){
       this.$refs['modal-reabrir'].show()
    },
    abrirModalCancelamento(){
       this.$refs['modal-cancelar'].show()
    },
    colorirTabSelecionada(idx) {
      if (this.tabIndex === idx) {
        if (idx === 1) return ['modern-tab-active-green', 'text-success']
        return ['modern-tab-active', 'text-primary']
      } else {
        return ['modern-tab-inactive', 'text-muted']
      }
    },
    avisosVenda(){
      let retorno = true
      if (!this.valN_VENDA) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Número do Pedido!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_CLI) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Cliente!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_VENDEDOR) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Vendedor!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valOP_FORMA_PAGTO) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe a forma de Pagamento!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if ((!this.tabelaItens.items.length) || (this.tabelaItens.items.length <= 0) ) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Adicione os Produtos!!`, {
          title: 'Aviso',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (this.venda.OP_FORMA_PAGTO === 'P' ) { // A PRAZO
         if (!this.valPAG1) {
          retorno = false
          this.toastCount++
          this.$root.$bvToast.toast(`Informe o número de Parcelas!! `, {
            title: 'Campo Obrigatório',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
         }
      }

      return retorno
    },
    avisosItem(){
      return this.valCOD_PRO && this.valQUANT
    },
    
    onHidden_botaoGerarDocumento() {
      // Return focus to the button
      //console.log(this.$refs)
      //this.$refs.ob_edDocumento.focus()
      this.$refs.edCOD_CLI.$refs.auto.$refs.autocomplete.focus()
    },
    onClick_botaoGerarDocumento() {
      this.controles.botaoGerarDocumento.submmited = true
      this.controles.botaoGerarDocumento.busy = true

      let uri = `/api/protected/vendapedido/getNovoNumeroDocumento`
      this.$http.get(uri)
      .then((data) => {
        this.venda.N_VENDA = data.data
        this.controles.botaoGerarDocumento.busy = false
      })
    },
    calcularPercentualLimiteCredito(){
      let credito = 0.00
      let usado = 0.00
      if (this.cliente.VL_CREDITO !== null && this.cliente.VL_CREDITO > 0) {
        credito = this.cliente.VL_CREDITO
      }
      if (this.cliente.LIMITE_CREDITO !== null && this.cliente.LIMITE_CREDITO > 0) {
        usado = this.cliente.LIMITE_CREDITO
      } 
      if (credito <= 0) {
        return 100
      } else {
        return 100 - ((credito - usado) / credito) * 100
      }
      
    },
    postProduto(){

    },
    post () {
      if ( !this.venda.SEQUENCIA || this.venda.SEQUENCIA === null || this.venda.SEQUENCIA === undefined ) {
        this.novo()
      } else {
        this.editar()
      }
    },
    editar() {
      this.$store.commit('controle/setAguardando', true)
      this.controles.botaoGerarDocumento.busy = false
      

      if (!this.isValid) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.controles.botaoGerarDocumento.busy = false
        return
      }
      if (this.venda.SEQUENCIA > 0) {
      this.$http.post(`/api/protected/vendapedido/edit`, this.venda)
        .then(response => {
          this.$store.commit('controle/setAguardando', true)
          this.$root.$bvToast.toast(`pedido ATUALIZADO com Sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
          this.voltar()
        })
        .catch(erro => {
          this.$root.$bvToast.toast(`Falha ao executar a operação!! ` + erro, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
          this.$store.commit('controle/setAguardando', false)
          this.controles.botaoGerarDocumento.busy = false
        })
      }
    },
    criarItem(alteracao, item) {
      this.item.CONTROLE                       =    item.CONTROLE                       ? item.CONTROLE                       : null 
      this.item.SEQUENCIA                      =    item.SEQUENCIA                      ? item.SEQUENCIA                      : null 
      this.item.COD_PRO                        =    item.COD_PRO                        ? item.COD_PRO                        : null 
      this.item.EAN                            =    item.EAN                            ? item.EAN                            : null 
      this.item.QUANT                          =    item.QUANT                          ? item.QUANT                          : 0.00 
      this.item.VL_UNT                         =    item.VL_UNT                         ? item.VL_UNT                         : 0.00 
      this.item.VL_CUSTO                       =    item.VL_CUSTO                       ? item.VL_CUSTO                       : 0.00 
      this.item.UND_PECAS                      =    item.UND_PECAS                      ? item.UND_PECAS                      : null 
      this.item.PECAS                          =    item.PECAS                          ? item.PECAS                          : 0 
      this.item.DT_VENDA                       =    item.DT_VENDA                       ? item.DT_VENDA                       : new Date() 
      this.item.TIPO_CLI                       =    item.TIPO_CLI                       ? item.TIPO_CLI                       : null 
      this.item.MARCA                          =    item.MARCA                          ? item.MARCA                          : null 
      this.item.TIPO_VEN                       =    item.TIPO_VEN                       ? item.TIPO_VEN                       : null 
      this.item.ALTERA                         =    item.ALTERA                         ? item.ALTERA                         : null 
      this.item.ITEM                           =    item.ITEM                           ? item.ITEM                           : null 
      this.item.VL_COMISSAO                    =    item.VL_COMISSAO                    ? item.VL_COMISSAO                    : 0.00 
      this.item.COD_CENTRO                     =    item.COD_CENTRO                     ? item.COD_CENTRO                     : null 
      this.item.ICMS                           =    item.ICMS                           ? item.ICMS                           : null 
      this.item.IPI                            =    item.IPI                            ? item.IPI                            : null 
      this.item.ISS                            =    item.ISS                            ? item.ISS                            : null 
      this.item.IRRF                           =    item.IRRF                           ? item.IRRF                           : null 
      this.item.ICMSSUBSTITUI                  =    item.ICMSSUBSTITUI                  ? item.ICMSSUBSTITUI                  : null 
      this.item.FORMA                          =    item.FORMA                          ? item.FORMA                          : null 
      this.item.ID_CFOP                        =    item.ID_CFOP                        ? item.ID_CFOP                        : null 
      this.item.OP_STATUS_PRECO                =    item.OP_STATUS_PRECO                ? item.OP_STATUS_PRECO                : null 
      this.item.VL_TOTAL_BRUTO                 =    item.VL_TOTAL_BRUTO                 ? item.VL_TOTAL_BRUTO                 : 0.00 
      this.item.VL_TOTAL_DESCONTO              =    item.VL_TOTAL_DESCONTO              ? item.VL_TOTAL_DESCONTO              : 0.00 
      this.item.VL_DESCONTO_PERC               =    item.VL_DESCONTO_PERC               ? item.VL_DESCONTO_PERC               : 0.00 
      this.item.TX_NCM                         =    item.TX_NCM                         ? item.TX_NCM                         : null 
      this.item.TX_NOME_PRODUTO                =    item.TX_NOME_PRODUTO                ? item.TX_NOME_PRODUTO                : null 
      this.item.TX_UNIDADE_COMERCIAL           =    item.TX_UNIDADE_COMERCIAL           ? item.TX_UNIDADE_COMERCIAL           : null 
      this.item.OP_OCORRENCIA_PRECO            =    item.OP_OCORRENCIA_PRECO            ? item.OP_OCORRENCIA_PRECO            : null 
      this.item.VL_DESCONTO                    =    item.VL_DESCONTO                    ? item.VL_DESCONTO                    : 0.00 
      this.item.UNIDADE_COMERCIAL_ID           =    item.UNIDADE_COMERCIAL_ID           ? item.UNIDADE_COMERCIAL_ID           : null 
      this.item.OP_TRIBUTACAO                  =    item.OP_TRIBUTACAO                  ? item.OP_TRIBUTACAO                  : null 
      this.item.CEST                           =    item.CEST                           ? item.CEST                           : null 
      this.item.QUANT_BKP                      =    item.QUANT_BKP                      ? item.QUANT_BKP                      : null 
      this.item.QUANT_RETORNO                  =    item.QUANT_RETORNO                  ? item.QUANT_RETORNO                  : null 
      this.item.PECAS_BKP                      =    item.PECAS_BKP                      ? item.PECAS_BKP                      : null 
      this.item.PECAS_RETORNO                  =    item.PECAS_RETORNO                  ? item.PECAS_RETORNO                  : null 
      this.item.OBS_RETORNO                    =    item.OBS_RETORNO                    ? item.OBS_RETORNO                    : null 
      this.item.TX_OBSERVACOES                 =    item.TX_OBSERVACOES                 ? item.TX_OBSERVACOES                 : null 
      
      if (alteracao == true) {
        this.item.OP_ICMS_SITUACAO_TRIBUTARIA    =    item.OP_ICMS_SITUACAO_TRIBUTARIA    ? item.OP_ICMS_SITUACAO_TRIBUTARIA    : null 
        this.item.OP_ICMS_ORIGEM                 =    item.OP_ICMS_ORIGEM                 ? item.OP_ICMS_ORIGEM                 : null 
        this.item.OP_ICMS_MODAL_DETERM_BC        =    item.OP_ICMS_MODAL_DETERM_BC        ? item.OP_ICMS_MODAL_DETERM_BC        : null 
        this.item.VL_ICMS_PERCENT_REDUC_BC       =    item.VL_ICMS_PERCENT_REDUC_BC       ? item.VL_ICMS_PERCENT_REDUC_BC       : null 
        this.item.VL_ICMS_BASE_CALC              =    item.VL_ICMS_BASE_CALC              ? item.VL_ICMS_BASE_CALC              : null 
        this.item.VL_ICMS_ALIQUOTA               =    item.VL_ICMS_ALIQUOTA               ? item.VL_ICMS_ALIQUOTA               : null 
        this.item.VL_ICMS                        =    item.VL_ICMS                        ? item.VL_ICMS                        : null 
        this.item.OP_ICMS_MODAL_DETERM_BC_ST     =    item.OP_ICMS_MODAL_DETERM_BC_ST     ? item.OP_ICMS_MODAL_DETERM_BC_ST     : null 
        this.item.VL_ICMS_MARGEM_VL_ADIC_ST      =    item.VL_ICMS_MARGEM_VL_ADIC_ST      ? item.VL_ICMS_MARGEM_VL_ADIC_ST      : null 
        this.item.VL_ICMS_PERCENT_REDUC_BC_ST    =    item.VL_ICMS_PERCENT_REDUC_BC_ST    ? item.VL_ICMS_PERCENT_REDUC_BC_ST    : null 
        this.item.VL_ICMS_BASE_CALC_ST           =    item.VL_ICMS_BASE_CALC_ST           ? item.VL_ICMS_BASE_CALC_ST           : null 
        this.item.VL_ICMS_ALIQUOTA_ST            =    item.VL_ICMS_ALIQUOTA_ST            ? item.VL_ICMS_ALIQUOTA_ST            : null 
        this.item.VL_ICMS_ST                     =    item.VL_ICMS_ST                     ? item.VL_ICMS_ST                     : null 
        this.item.OP_IPI_SITUACAO_TRIBUTARIA     =    item.OP_IPI_SITUACAO_TRIBUTARIA     ? item.OP_IPI_SITUACAO_TRIBUTARIA     : null 
        this.item.OP_IPI_CLASS_ENQ_CIG_BEB       =    item.OP_IPI_CLASS_ENQ_CIG_BEB       ? item.OP_IPI_CLASS_ENQ_CIG_BEB       : null 
        this.item.TX_IPI_CODIGO_ENQUAD_LEGAL     =    item.TX_IPI_CODIGO_ENQUAD_LEGAL     ? item.TX_IPI_CODIGO_ENQUAD_LEGAL     : null 
        this.item.TX_IPI_CNPJ_PRODUTOR           =    item.TX_IPI_CNPJ_PRODUTOR           ? item.TX_IPI_CNPJ_PRODUTOR           : null 
        this.item.TX_IPI_NUM_SELO_CONTROLE       =    item.TX_IPI_NUM_SELO_CONTROLE       ? item.TX_IPI_NUM_SELO_CONTROLE       : null 
        this.item.OP_IPI_TIPO_CALCULO            =    item.OP_IPI_TIPO_CALCULO            ? item.OP_IPI_TIPO_CALCULO            : null 
        this.item.VL_IPI_BASE_CALC               =    item.VL_IPI_BASE_CALC               ? item.VL_IPI_BASE_CALC               : null 
        this.item.VL_IPI_ALIQUOTA                =    item.VL_IPI_ALIQUOTA                ? item.VL_IPI_ALIQUOTA                : null 
        this.item.VL_IPI_QUANT_TOTAL_UND_PADRAO  =    item.VL_IPI_QUANT_TOTAL_UND_PADRAO  ? item.VL_IPI_QUANT_TOTAL_UND_PADRAO  : null 
        this.item.VL_IPI_UNIDADE                 =    item.VL_IPI_UNIDADE                 ? item.VL_IPI_UNIDADE                 : null 
        this.item.VL_IPI                         =    item.VL_IPI                         ? item.VL_IPI                         : null 
        this.item.OP_PIS_SITUACAO_TRIBUTARIA     =    item.OP_PIS_SITUACAO_TRIBUTARIA     ? item.OP_PIS_SITUACAO_TRIBUTARIA     : null 
        this.item.OP_PIS_TIPO_CALCULO            =    item.OP_PIS_TIPO_CALCULO            ? item.OP_PIS_TIPO_CALCULO            : null 
        this.item.VL_PIS_BASE_CALC               =    item.VL_PIS_BASE_CALC               ? item.VL_PIS_BASE_CALC               : null 
        this.item.VL_PIS_ALIQUOTA_PERCENT        =    item.VL_PIS_ALIQUOTA_PERCENT        ? item.VL_PIS_ALIQUOTA_PERCENT        : null 
        this.item.VL_PIS_ALIQUOTA_REAIS          =    item.VL_PIS_ALIQUOTA_REAIS          ? item.VL_PIS_ALIQUOTA_REAIS          : null 
        this.item.VL_PIS_QUANT_VENDIDA           =    item.VL_PIS_QUANT_VENDIDA           ? item.VL_PIS_QUANT_VENDIDA           : null 
        this.item.VL_PIS                         =    item.VL_PIS                         ? item.VL_PIS                         : null 
        this.item.OP_PISST_TIPO_CALCULO          =    item.OP_PISST_TIPO_CALCULO          ? item.OP_PISST_TIPO_CALCULO          : null 
        this.item.VL_PISST_BASE_CALC             =    item.VL_PISST_BASE_CALC             ? item.VL_PISST_BASE_CALC             : null 
        this.item.VL_PISST_ALIQUOTA_PERCENT      =    item.VL_PISST_ALIQUOTA_PERCENT      ? item.VL_PISST_ALIQUOTA_PERCENT      : null 
        this.item.VL_PISST_ALIQUOTA_REAIS        =    item.VL_PISST_ALIQUOTA_REAIS        ? item.VL_PISST_ALIQUOTA_REAIS        : null 
        this.item.VL_PISST_QUANT_VENDIDA         =    item.VL_PISST_QUANT_VENDIDA         ? item.VL_PISST_QUANT_VENDIDA         : null 
        this.item.VL_PISST                       =    item.VL_PISST                       ? item.VL_PISST                       : null 
        this.item.OP_COFINS_SITUACAO_TRIBUTARIA  =    item.OP_COFINS_SITUACAO_TRIBUTARIA  ? item.OP_COFINS_SITUACAO_TRIBUTARIA  : null 
        this.item.OP_COFINS_TIPO_CALCULO         =    item.OP_COFINS_TIPO_CALCULO         ? item.OP_COFINS_TIPO_CALCULO         : null 
        this.item.VL_COFINS_BASE_CALC            =    item.VL_COFINS_BASE_CALC            ? item.VL_COFINS_BASE_CALC            : null 
        this.item.VL_COFINS_ALIQUOTA_PERCENT     =    item.VL_COFINS_ALIQUOTA_PERCENT     ? item.VL_COFINS_ALIQUOTA_PERCENT     : null 
        this.item.VL_COFINS_ALIQUOTA_REAIS       =    item.VL_COFINS_ALIQUOTA_REAIS       ? item.VL_COFINS_ALIQUOTA_REAIS       : null 
        this.item.VL_COFINS_QUANT_VENDIDA        =    item.VL_COFINS_QUANT_VENDIDA        ? item.VL_COFINS_QUANT_VENDIDA        : null 
        this.item.VL_COFINS                      =    item.VL_COFINS                      ? item.VL_COFINS                      : null 
        this.item.OP_COFINSST_TIPO_CALCULO       =    item.OP_COFINSST_TIPO_CALCULO       ? item.OP_COFINSST_TIPO_CALCULO       : null 
        this.item.VL_COFINSST_BASE_CALC          =    item.VL_COFINSST_BASE_CALC          ? item.VL_COFINSST_BASE_CALC          : null 
        this.item.VL_COFINSST_ALIQUOTA_PERCENT   =    item.VL_COFINSST_ALIQUOTA_PERCENT   ? item.VL_COFINSST_ALIQUOTA_PERCENT   : null 
        this.item.VL_COFINSST_ALIQUOTA_REAIS     =    item.VL_COFINSST_ALIQUOTA_REAIS     ? item.VL_COFINSST_ALIQUOTA_REAIS     : null 
        this.item.VL_COFINSST_QUANT_VENDIDA      =    item.VL_COFINSST_QUANT_VENDIDA      ? item.VL_COFINSST_QUANT_VENDIDA      : null 
        this.item.VL_COFINSST                    =    item.VL_COFINSST                    ? item.VL_COFINSST                    : null 
        
        this.item.OP_COMPOE_VALOR_NFE            =    item.OP_COMPOE_VALOR_NFE            ? item.OP_COMPOE_VALOR_NFE            : null 
        this.item.VL_ICMS_BC_ST_RETIDO_ANT       =    item.VL_ICMS_BC_ST_RETIDO_ANT       ? item.VL_ICMS_BC_ST_RETIDO_ANT       : null 
        this.item.VL_ICMS_ST_RETIDO_ANT          =    item.VL_ICMS_ST_RETIDO_ANT          ? item.VL_ICMS_ST_RETIDO_ANT          : null 
        this.item.VL_ICMS_PERC_BC_OPER_PROPRIA   =    item.VL_ICMS_PERC_BC_OPER_PROPRIA   ? item.VL_ICMS_PERC_BC_OPER_PROPRIA   : null 
        this.item.ID_UF_ICMS_ST                  =    item.ID_UF_ICMS_ST                  ? item.ID_UF_ICMS_ST                  : null 
        this.item.VL_CREDITO_ICMS_APROVEITADO    =    item.VL_CREDITO_ICMS_APROVEITADO    ? item.VL_CREDITO_ICMS_APROVEITADO    : null 
        
      
        this.item.OP_MOTIVO_DESONERACAO          =    item.OP_MOTIVO_DESONERACAO          ? item.OP_MOTIVO_DESONERACAO          : null 
        this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO =    item.VL_ALIQ_APLICAVEL_CALC_CREDITO ? item.VL_ALIQ_APLICAVEL_CALC_CREDITO : null 
      }
    },
    async limparVenda () {
      
      this.venda.SEQUENCIA                 = null
      this.venda.N_VENDA                   = null
      this.venda.DT_SAIDA                  = null
      this.venda.COD_CLI                   = null
      this.venda.DT_PAG                    = null
      this.venda.PAG1                      = null
      this.venda.PAG2                      = '0'
      this.venda.PAG3                      = null
      this.venda.PAG4                      = null
      this.venda.PAG5                      = null
      this.venda.TIPO                      = null
      this.venda.TIPO_VEN                  = '0'
      this.venda.FORMA                     = 'VENDA'
      this.venda.COD_VENDEDOR              = null
      this.venda.COD_MOTORISTA             = null
      this.venda.VL_TOTAL                  = null
      this.venda.OBS2                      = null
      this.venda.OBS3                      = null
      this.venda.LOTE                      = null
      this.venda.TIPO_DOCPAG               = null
      this.venda.N_DOCPAG                  = null
      this.venda.COD_REPRES                = null
      this.venda.COD_CONFERENTE            = null
      this.venda.TIPO_VENDEDOR             = null
      this.venda.ITENS                     = null
      this.venda.NENTREGA                  = '0'
      this.venda.PLACA                     = null
      this.venda.VL_ENTRADA                = null
      this.venda.VL_DESCONTO               = null
      this.venda.CFOP                      = null
      this.venda.UFENT                     = null
      this.venda.TELENT                    = null
      this.venda.CONTATOENT                = null
      this.venda.BAIRROENT                 = null
      this.venda.CIDADEENT                 = null
      this.venda.ENDENT                    = null
      this.venda.USUARIO                   = null
      this.venda.MOT_CANC                  = null
      this.venda.NUMNF                     = null
      this.venda.SERIENF                   = null
      this.venda.UFPLACA                   = null
      this.venda.PORCONTA                  = null
      this.venda.VOLUMES                   = null
      this.venda.PESOLIQUIDO               = 0.00
      this.venda.PESOBRUTO                 = 0.00
      this.venda.TOTALNF                   = null
      this.venda.DT_CANC                   = null
      this.venda.DT_ALTERACAO              = null
      this.venda.TX_USUARIO_ALTERACAO      = null
      this.venda.VL_TOTAL_ANTES_ALTERACAO  = 0.00
      this.venda.VL_BASE_CALC_ICMS         = 0.00
      this.venda.VL_TOTAL_ICMS             = 0.00
      this.venda.VL_BASE_CALC_ST_ICMS      = 0.00
      this.venda.VL_TOTAL_ST_ICMS          = 0.00
      this.venda.VL_TOTAL_IPI              = 0.00
      this.venda.VL_TOTAL_PIS              = 0.00
      this.venda.VL_TOTAL_COFINS           = 0.00
      this.venda.VL_TOTAL_DESCONTO         = 0.00
      this.venda.VL_TOTAL_SEGURO           = 0.00
      this.venda.VL_TOTAL_OUTRAS_DESP      = 0.00
      this.venda.VL_TOTAL_FRETE            = 0.00
      this.venda.NR_PESO_BRUTO             = 0.00
      this.venda.VL_TOTAL_PRODUTOS         = 0.00
      this.venda.NR_PESO_LIQUIDO           = 0.00
      this.venda.VL_TOTAL_NFE              = 0.00
      this.venda.OP_FORMA_PAGTO            = 'V'
      this.venda.TX_USUARIO_CANCELAMENTO   = null
      this.venda.NR_PARCELAS               = null
      this.venda.COD_TRANSP                = null
      this.venda.ORIGEM                    = null
      this.venda.DT_PREVISAO_ENTREGA       = null
      this.venda.HORA                      = null
      this.venda.DT_PEDIDO                 = null
      this.venda.DT_SISTEMA_CANCELAMENTO   = null
      this.venda.DT_CADASTRO_SISTEMA       = null
      this.venda.DT_ALTERACAO_SISTEMA      = null
      this.venda.OBSERVACOES               = null
      this.venda.SITUACAO                  = '2'
      this.venda.DT_RETORNO                = null
      this.venda.NOME_RESPONSAVEL_RETORNO  = null
      this.venda.DT_LANCAMENTO_RETORNO     = null
      this.venda.OBS_RETORNO               = null
      this.venda.USUARIO_RETORNO           = null
      this.venda.VL_TOTAL_RETORNO_BKP      = 0.00
      this.venda.VL_TOTAL_RETORNO          = 0.00
      this.venda.DT_LANCAMENTO_WEB         = null
      this.venda.OP_LANCAMENTO_WEB         = null
      this.venda.USUARIO_LANCAMENTO_WEB    = null
      this.venda.OBS_PEDIDO                = null
      this.venda.DT_INICIAR_PAGAMENTO      = moment(new Date()).format('YYYY-MM-DD')
        

    },
    async iniciarFormEditar (id) {
      try {
        this.controles.situacaoCliente = 'Cliente'
        this.$store.commit('controle/setAguardando', true)

        const uri = `/api/protected/vendapedido/getById/${id}`
        const response = await this.$http.get(uri)

        if (!response.data || !response.data.length) {
          this.$bvToast.toast(`Falha ao executar a operação!!`, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
          this.voltar()
          this.$store.commit('controle/setAguardando', false)
          return false
        }

        if (response.data[0].SEQUENCIA === '') {
          this.$bvToast.toast(`Falha ao executar a operação!!`, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
          this.voltar()
          this.$store.commit('controle/setAguardando', false)
          return false
        }

        const vendaData = response.data[0]
        vendaData.DT_SAIDA = vendaData.DT_SAIDA ? Tools.formatarDataParaInput(vendaData.DT_SAIDA) : null
        vendaData.DT_PEDIDO = Tools.formatarDataParaInput(vendaData.DT_PEDIDO)
        vendaData.DT_INICIAR_PAGAMENTO = vendaData.DT_INICIAR_PAGAMENTO ? Tools.formatarDataParaInput(Tools.getDataAtual()) : null

        this.venda = vendaData
        this.vlTotalAntes = this.venda.VL_TOTAL_NFE

        if (this.venda.SITUACAO != '2') {
          this.controles.fechada = true
          this.controles.campoGerarDocumento.desabilitado = true
        } else {
          this.controles.fechada = false
          this.controles.campoGerarDocumento.desabilitado = !!this.venda.N_VENDA
        }

        this.$store.commit('controle/setAguardando', false)

        // carregar itens da venda
        try {
          const itensResp = await this.$http.get('/api/protected/vendapedido/item/getListagemByVenda/' + this.venda.SEQUENCIA)
          this.tabelaItens.items = []
          if (itensResp.data && itensResp.data.length) {
            for (let i = 0; i < itensResp.data.length; i++) {
              if ((itensResp.data[i].VL_UNT) && (itensResp.data[i].VL_UNT > 0)) {
                itensResp.data[i].VL_UNT = itensResp.data[i].VL_UNT.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 })
              }
              this.tabelaItens.items.push(itensResp.data[i])
            }
          }
        } catch (errItems) {
          // se falhar ao carregar itens, exibir mensagem mas manter usuário na tela de edição
          this.$bvToast.toast(`Falha ao carregar itens do pedido!! ${errItems}`, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        }

        return true
      } catch (err) {
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Falha ao executar a operação!! ${err}`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
        this.voltar()
        return false
      }
    },
    async atualizarPrecoVenda() {
      try {
        const result = await this.$http.get(`api/protected/vendapedido/item/getAchaPrecoLivre/${this.venda.COD_CLI}/${this.item.COD_PRO}`)
        if (result && result.data && result.data[0]) {
          this.item.VL_UNT = result.data[0].PRECO
          this.item.VL_CUSTO = result.data[0].CUSTO
        }
      } catch (err) {
        this.$bvToast.toast(`Falha ao obter preço!! ${err}`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
      }
    },

    async carregarParametros () {
      try {
        this.parametros = {}
        const uri = this.$http.defaults.baseURL.concat('api/protected/parametro/getDados')
        const result = await this.$http.get(uri)

        if (result && result.data && result.data.length) {
          this.parametros = result.data[0]
          this.precoTabelado = this.parametros.OP_VENDA_PRECO_POR_TABELA === 'T'
          this.venda.OBSERVACOES = `${this.parametros.LINHA1ROMA}\n${this.parametros.LINHA2ROMA}\n${this.parametros.LINHA3ROMA}`
        }

        return true
      } catch (err) {
        this.$root.$bvToast.toast(`Falha ao atualizar os Parametros do Sistema!! ${err}`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
        return false
      }
    },
    handleMouseDownAcrescentarItem(item) {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarAcrescimoItem(item);
      }, 500); // 0.5 segundos para começar o incremento contínuo
    },
    handleMouseUpAcrescentarItem(item) {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.acrescentarItemSimples(item);
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveAcrescentarItem() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarAcrescimoItem(item) {
      this.intervaloBotao = setInterval(() => {
        if (item.PECAS_PEDIDO + 10 <= item.PECAS) {
          item.PECAS_PEDIDO += 10;
        } else {
          item.PECAS_PEDIDO = item.PECAS;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Incrementa 10 a cada 0.1 segundo (100ms)
    },
    acrescentarItemSimples(item) {
      if (item.PECAS_PEDIDO + 1 <= item.PECAS) {
        item.PECAS_PEDIDO += 1;
      } else {
        item.PECAS_PEDIDO = item.PECAS;
      }
    },
    handleMouseDownDecrementarItem(item) {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarDecrementoItem(item);
      }, 500); // 0.5 segundos para começar o decremento contínuo
    },
    handleMouseUpDecrementarItem(item) {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.decrementoItemSimples(item);
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveDecrementarItem() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarDecrementoItem(item) {
      this.intervaloBotao = setInterval(() => {
        if (item.PECAS_PEDIDO - 10 >= 0) {
          item.PECAS_PEDIDO -= 10;
        } else {
          item.PECAS_PEDIDO = 0;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Decrementa 10 a cada 0.1 segundo (100ms)
    },
    decrementoItemSimples(item) {
      if (item.PECAS_PEDIDO - 1 >= 0) {
        item.PECAS_PEDIDO -= 1;
      } else {
        item.PECAS_PEDIDO = 0;
      }
    },
    handleMouseDownAcrescentarItemAlteracao() {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarAcrescimoItemAlteracao();
      }, 500); // 0.5 segundos para começar o incremento contínuo
    },
    handleMouseUpAcrescentarItemAlteracao() {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.acrescentarItemSimplesAlteracao();
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveAcrescentarItemAlteracao() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarAcrescimoItemAlteracao(item) {
      this.intervaloBotao = setInterval(() => {
        if (this.itemAlteracao.PECAS_PEDIDO + 10 <= this.itemAlteracao.PECAS_ESTOQUE) {
          this.itemAlteracao.PECAS_PEDIDO += 10
        } else {
          this.itemAlteracao.PECAS_PEDIDO = this.itemAlteracao.PECAS_ESTOQUE
          clearInterval(this.intervaloBotao)
        }
      }, 100); // Incrementa 10 a cada 0.1 segundo (100ms)
    },
    acrescentarItemSimplesAlteracao() {
      if (this.itemAlteracao.PECAS_PEDIDO + 1 <= this.itemAlteracao.PECAS_ESTOQUE) {
        this.itemAlteracao.PECAS_PEDIDO += 1
      } else {
        this.itemAlteracao.PECAS_PEDIDO = this.itemAlteracao.PECAS_ESTOQUE
      }
    },
    handleMouseDownDecrementarItemAlteracao() {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarDecrementoItemAlteracao();
      }, 500); // 0.5 segundos para começar o decremento contínuo
    },
    handleMouseUpDecrementarItemAlteracao() {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.decrementoItemSimplesAlteracao();
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveDecrementarItemAlteracao() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarDecrementoItemAlteracao() {
      this.intervaloBotao = setInterval(() => {
        if (this.itemAlteracao.PECAS_PEDIDO - 10 >= 0) {
          this.itemAlteracao.PECAS_PEDIDO -= 10;
        } else {
          this.itemAlteracao.PECAS_PEDIDO = 0;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Decrementa 10 a cada 0.1 segundo (100ms)
    },
    decrementoItemSimplesAlteracao() {
      if (this.itemAlteracao.PECAS_PEDIDO - 1 >= 0) {
        this.itemAlteracao.PECAS_PEDIDO -= 1;
      } else {
        this.itemAlteracao.PECAS_PEDIDO = 0;
      }
    },
    usarPreco(item) {
      item.VL_UNT = item.ULTIMO_PRECO
    },
    removerPecas(item) {
      if (item.PECAS_PEDIDO > 0 ) {
        item.PECAS_PEDIDO--
      }
    },
    
    
    forceValidation(linha) {
      const maxPecas = parseInt(linha.item.PECAS, 10);
      let currentPecas = parseInt(linha.item.PECAS_PEDIDO, 10);

      if (currentPecas > maxPecas) {
        linha.item.PECAS_PEDIDO = maxPecas;
      }
    },
    
    fecharModalListaProdutos() {
      clearTimeout(this.timerBotao)
      clearInterval(this.intervaloBotao)

      this.limparCriticaEstoqueModal()
      this.$store.commit('controle/setAguardando', true)
      let itensSelecionados = []
      for (let i = 0; i < this.produtos.items.length; i++) {
        if (this.produtos.items[i].PECAS_PEDIDO > 0) {
          itensSelecionados.push(this.produtos.items[i])
          if ((typeof this.produtos.items[i].VL_UNT === 'undefined') || (this.produtos.items[i].VL_UNT === null) || (this.produtos.items[i].VL_UNT === 0) )  {
            this.$store.commit('controle/setAguardando', false)
            this.toastCount++
            this.$root.$bvToast.toast(`Informe o preço do Produto: ${this.produtos.items[i].DESCRICAO_PRODUTO}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
            return
          }
        }
      }
      
      let pacote = {
        venda: this.venda,
        items: itensSelecionados

      }
      this.$http.post(`/api/protected/vendapedido/item/postItensPedido`,pacote)
      .then(async response => {
        this.tabelaItens.items = []
          if ( (response.data) && (response.data.length) ) {
            for (let i = 0; i < response.data.length; i++) {
              if ((response.data[i].VL_UNT) && (response.data[i].VL_UNT > 0) ) {
                  response.data[i].VL_UNT = response.data[i].VL_UNT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2})
              }
              this.tabelaItens.items.push(response.data[i])
            }  
            
          }
        await this.atualizarVendaAtual()
        this.$refs['modal-lista-produtos'].hide()
        this.$store.commit('controle/setAguardando', false)
      })
.catch(err => {
        this.$store.commit('controle/setAguardando', false)
        if (err.response && err.response.data && err.response.data.tipo === 'ESTOQUE_INSUFICIENTE') {
          this.aplicarCriticaEstoqueModal(err.response.data)
          return
        }
        if (err.response && err.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${err.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
        }
      })
      
    },
    async carregarListaProdutos() {
      return new Promise((resolve, reject) => {
        let uri = this.$http.defaults.baseURL.concat('api/protected/estoque/getEstoqueDoPedidoDeVenda/'+this.venda.SEQUENCIA+'/'+this.venda.COD_CLI)
        this.$http.get(uri)
        .then((result) => {
          this.limparCriticaEstoqueModal()
          this.produtos.items = []
          this.filter = null
          for (let i = 0; i < result.data.length; i++) {
            // result.data[i].PECAS_PEDIDO = 0
            if ( (result.data[i].PECAS_PEDIDO == null ) || (result.data[i].PECAS_PEDIDO <= 0)) {
              result.data[i].PECAS_PEDIDO = 0
            }
            if ( (result.data[i].VL_UNT == null ) || (result.data[i].VL_UNT <= 0)) {
              result.data[i].VL_UNT = 0
            }
            //Contornar a questão do estoque zerado ou negativo
            if ( (result.data[i].PECAS == null ) || (result.data[i].PECAS <= 0)) {
              result.data[i].PECAS = this.pecasEstoqueNegativo
            }
            result.data[i]._estoqueCritico = false
            this.produtos.items.push(result.data[i])
          }
          this.produtos.totalRows = this.produtos.items.length
          resolve(true)
          return
        }).catch((err) => {
          this.$root.$bvToast.toast(`Não foi possível carregar o estoque dos produtos!! ${err}`, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
          reject(false)
          return
        })
      })
      
    },
    async carregarAlteracaoProduto(id) {
      return new Promise((resolve, reject) => {
        let uri = '/api/protected/estoque/getEstoqueDoPedidoDeVendaPorItem/'+id
        this.$http.get(uri)
        .then((result) => {
          if ((!result.data) || (!result.data.length)) {
            this.$root.$bvToast.toast(`Não foi possível carregar o item Selecionado!! ${err}`, {
              title: 'Aviso',
              autoHideDelay: 5000,
              variant: 'danger',
              appendToast: true
            })
            reject(false)
            return
          }

          this.itemAlteracao.CONTROLE = null
          this.itemAlteracao.COD_PRO = null
          this.itemAlteracao.CODIGO_NOME_PRODUTO = ''
          this.itemAlteracao.PECAS_ESTOQUE = 0
          this.itemAlteracao.PECAS_PEDIDO = 0
          this.itemAlteracao.TX_UNIDADE_COMERCIAL = ''
          this.itemAlteracao.VL_UNT = 0.00
          this.itemAlteracao.VL_MASK = 0.00

         
          
          if ( (result.data[0].PECAS_PEDIDO == null ) || (result.data[0].PECAS_PEDIDO <= 0)) {
            result.data[0].PECAS_PEDIDO = 0
          }
          if ( (result.data[0].VL_UNT == null ) || (result.data[0].VL_UNT <= 0)) {
            result.data[0].VL_UNT = 0
          }

          //Contornar a questão do estoque zerado ou negativo
          if ( (result.data[0].PECAS == null ) || (result.data[0].PECAS <= 0)) {
              result.data[0].PECAS = this.pecasEstoqueNegativo
            }

          this.itemAlteracao.CONTROLE = result.data[0].CONTROLE
          this.itemAlteracao.COD_PRO = result.data[0].PRODUTO_ID
          this.itemAlteracao.CODIGO_NOME_PRODUTO = result.data[0].DESCRICAO_PRODUTO
          this.itemAlteracao.PECAS_ESTOQUE = result.data[0].PECAS_ESTOQUE
          this.itemAlteracao.PECAS_PEDIDO = result.data[0].PECAS_PEDIDO
          this.itemAlteracao.TX_UNIDADE_COMERCIAL = result.data[0].UNIDADE_COMERCIAL_ID
          this.itemAlteracao.VL_UNT = result.data[0].VL_UNT
          this.itemAlteracao.VL_UNT_MASK   = result.data[0].VL_UNT ? result.data[0].VL_UNT.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          

          resolve(true)
          return
        }).catch((err) => {
          this.$store.commit('controle/setAguardando', false)
          if (err.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${err.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          } else {
            this.$root.$bvToast.toast(`Não foi possível carregar o item!! ${err}`, {
              title: 'Erro',
              autoHideDelay: 5000,
              variant: 'danger',
              appendToast: true
            })
          }
          reject(false)
          return
        })
      })
      
    },
    colorirLimiteCredito(valor) {
      if (valor === 0) return 'primary'
      else if (valor > 0) return 'success'
      else return 'danger'
    },
    traduzirSituacao(value) {
      let $variant
      if ( value == '0'  ) {
        $variant = 'CANCELADO'
      } else if ( value == '1'  ) {
        $variant = 'FATURADO'
      } else if ( value == '2'  ) {
        $variant = 'EM CADASTRO'
      } else if ( value == '3'  ) {
        $variant = 'AGUARDANDO ORDEM'
      } else if ( value == '4'  ) {
        $variant = 'ORDEM EXPEDIÇÃO'
      } else if ( value == '5'  ) {
        $variant = 'EMBARCANDO'
      } else if ( value == '6'  ) {
        $variant = 'EMBARCADO'
      }
      return $variant
    },
    variantSituacao (value) {
      let $variant
      if ( value == '0'  ) {
        $variant = 'danger'
      } else if ( value == '1'  ) {
        $variant = 'success'
      } else if ( value == '2'  ) {
        $variant = 'warning'
      } else if ( value == '3'  ) {
        $variant = 'info'
      } else if ( value == '4'  ) {
        $variant = 'warning'
      } else if ( value == '5'  ) {
        $variant = 'info'
      } else if ( value == '6'  ) {
        $variant = 'primary'
      }
      return $variant
    },
    async getVendedorId() {
      return new Promise((resolve, reject) => {
        this.$http.get('/api/protected/usuario/getVendedorId?login='+window.localStorage.getItem('login'))
        .then((result) => {
          if ((result.data) && (result.data.VENDEDOR_ID)) {
            this.venda.COD_VENDEDOR = result.data.VENDEDOR_ID
            resolve(true)
            return
          } else {
            reject(false)
            return
          }
          
          
        }).catch((err) => {
          this.$root.$bvToast.toast(`Não foi possível localizar o vendedor!! ${err}`, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
          reject(false)
          return
        })
      })
      
    },
    adicionarDiasInicioPagamento(dias) {
      if (!this.venda.DT_PEDIDO) {
        this.venda.DT_PEDIDO = Tools.getDataAtual()
      }

      const diasInt = parseInt(dias)
      if (isNaN(diasInt)) {
        console.warn('Dias inválido:', dias)
        return
      }

      this.venda.DT_INICIAR_PAGAMENTO = Tools.getAcrescentarData(this.venda.DT_PEDIDO, diasInt, 'dias')
    },
    async atualizarCliente() {
      try {
        const response = await this.$http.get(`/api/protected/clientes/getDetalhesParaVenda/${this.venda.COD_CLI}`)
        const cliente = response.data[0]

        if (!cliente) {
          throw new Error('Cliente não encontrado')
        }

        this.cliente = cliente

        if (!this.controles.vendaAlteracao) {
          // Resetar a forma de pagamento
          this.venda.OP_FORMA_PAGTO = null
          await this.$nextTick()

          // Forma de pagamento
          this.venda.OP_FORMA_PAGTO = cliente.FORMA_PAGAMENTO || 'V'

          //Dias
          this.diasIniciarPagamento = cliente.DIAS_INICIAR_PAGAMENTO != null ? parseInt(cliente.DIAS_INICIAR_PAGAMENTO) : 0
          
          //A parir de
          if (this.diasIniciarPagamento == 30 ) {
            this.venda.DT_INICIAR_PAGAMENTO = Tools.getAcrescentarData(this.venda.DT_PEDIDO, this.diasIniciarPagamento, 'meses')
          } else {
            this.venda.DT_INICIAR_PAGAMENTO = Tools.getAcrescentarData(this.venda.DT_PEDIDO, this.diasIniciarPagamento, 'dias')
          }
            
          //ComboVezes
          this.venda.NR_PARCELAS =  cliente.PRAZO
          //comboDias
          this.venda.PAG1 = cliente.DIAS_ENTRE_PARCELAS?? null
        }

        // Situação financeira
        if (cliente.OP_SITUACAO_FINANCEIRO === '1') {
          this.controles.situacaoCliente = 'Cliente: BLOQUEADO'
          this.controles.clienteBloqueado = true
          this.$root.$bvToast.toast(`Cliente Bloqueado!!!`, {
            title: 'Aviso',
            autoHideDelay: 4000,
            variant: 'danger',
            appendToast: true
          })
        } else {
          this.controles.situacaoCliente = 'Cliente: LIBERADO'
          this.controles.clienteBloqueado = false
        }

        return true

      } catch (error) {
        console.error('Erro ao atualizar cliente:', error)
        return false
      }
    },
    resetarCliente() {
      this.cliente = {
        CODIGO: null,
        NOME: null,
        RAZAOSOCIAL: null,
        ID_UF: null,
        FIZ_JUR: null,
        ISENTO_ICMS: null,
        COD_VEND: null,
        LIMITE_CREDITO: 0.00,
        NOTAS_EM_ABERT0: 0,
        PRAZO: null,
        TIPO_CLI: null,
        GRUPO_ARECEBER_ID: null
      }

      this.venda.OP_FORMA_PAGTO = 'V'
      this.venda.NR_PARCELAS = '1'
      this.venda.PAG1 = '0'
      this.venda.DT_INICIAR_PAGAMENTO = null

      this.controles.situacaoCliente = 'Cliente:'
      this.controles.clienteBloqueado = false
    }

  },
  beforeDestroy() {
    clearTimeout(this.timerBotao)
    clearInterval(this.intervaloBotao)
  },
  async created () {
    let id = this.$route.params.id
    
    await this.carregarParametros()
    this.gerarComboParcelas()
    this.gerarDias()
    if ( id ) {
      await this.iniciarFormEditar( id )
      this.vendaIdEditar = id
      this.controles.vendaAlteracao = true
      //VENDA FECHADA
      
    } else {
      await this.limparVenda()
      this.vendaIdEditar = null
      this.controles.vendaAlteracao = false
      this.controles.fechada = false
      this.controles.campoGerarDocumento.desabilitado = false
      this.venda.SITUACAO = '2' // ABERTO LANCANDO 
      this.venda.NENTREGA = '0'
      this.venda.DT_PEDIDO = Tools.getDataAtual()
      this.venda.DT_SAIDA = null
      this.venda.DT_INICIAR_PAGAMENTO = Tools.getDataAtual()
      this.venda.FORMA = 'VENDA'
      this.venda.TIPO_VEN = '1'
      this.venda.PAG2 = '0'
      this.venda.OP_PEDIDO = '1'
      this.venda.USUARIO_PEDIDO = window.localStorage.getItem('login')
      this.venda.OP_FORMA_PAGTO = 'P'


      await this.getVendedorId()

    }
    this.$store.commit('controle/setAguardando', false)
  },
  mounted (){
    let id = this.$route.params.id
    if ( id == null  ) {
      //this.$refs.ob_edDocumento.focus()
      this.$refs.edCOD_CLI.$refs.auto.$refs.autocomplete.focus()
    }
  },
  watch: {
    'venda.OP_FORMA_PAGTO': function () {
      if (this.venda.OP_FORMA_PAGTO == 'P') {
        if ( (this.venda.DT_INICIAR_PAGAMENTO == null ) || (this.venda.DT_INICIAR_PAGAMENTO <  moment(new Date()).format('YYYY-MM-DD')  ) ) {
          this.venda.DT_INICIAR_PAGAMENTO  = moment(new Date()).format('YYYY-MM-DD')    
        }
      }
    },
    'apenasLancados': function (val) {
      this.produtos.currentPage = 1
      if (!this.filter) {
        this.produtos.totalRows = this.filteredProducts.length
      }
    },
    'venda.COD_CLI': async function() {
      //console.log('>>> COD_CLI mudou para:', this.venda.COD_CLI)
      
      if (this.venda.COD_CLI === null) {
        this.resetarCliente()
        return
      }

      const sucesso = await this.atualizarCliente()
      
      //console.log('>>> Finalizou atualizarCliente. venda.OP_FORMA_PAGTO:', this.venda.OP_FORMA_PAGTO)

      if (!sucesso) {
        this.toastCount++
        this.$root.$bvToast.toast(`Falha ao atualizar o Cliente!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
      }
    }
    
  }
}
</script>



<style lang="scss" scoped>
::v-deep .modal-luxury {
  .modal-dialog {
    margin: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .modal-content {
    border-radius: 0;
    border: none;
    background-color: #f1f5f9;
    min-height: 100vh;
  }
  .modal-header {
    background-color: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    padding: 0.6rem 0.8rem;
  }
  .modal-body {
    padding: 2px !important;
    overflow-x: hidden !important;
  }
  .table {
    table-layout: fixed !important;
    width: 100% !important;
    margin: 0 !important;
    td {
      padding: 0 !important;
      border: none !important;
    }
  }
  .modal-footer {
    padding: 0;
    border-top: 1px solid #e2e8f0;
  }
}

.stock-banner-modal {
  background: #fff7ed;
  border: 1px solid #fdba74;
  border-radius: 10px;
  padding: 10px 12px;
  color: #9a3412;

  .stock-banner-title {
    font-size: 0.78rem;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 2px;
  }

  .stock-banner-message {
    font-size: 0.72rem;
    font-weight: 600;
    margin-bottom: 6px;
  }

  .stock-banner-item {
    font-size: 0.7rem;
    line-height: 1.4;
  }
}

.modern-search {
  border-radius: 8px 0 0 8px !important;
  border: 1px solid #e2e8f0;
  border-right: none;
  padding: 0.5rem 0.8rem;
  height: 42px;
  font-size: 0.9rem;
  background-color: #f8fafc;
  transition: all 0.3s ease;
  &:focus {
    background-color: #ffffff;
    border-color: #3b82f6;
    box-shadow: none;
  }
}

.btn-search-back {
  border-radius: 0 8px 8px 0 !important;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: none;
  color: #64748b;
  width: 42px;
  height: 42px;
  &:hover, &:active { background-color: #f1f5f9; color: #1e293b; }
}

.product-card-pro {
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 0 8px 8px 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  width: auto;
  box-sizing: border-box;

  &.is-selected {
    border-color: #3b82f6;
    background: #f0f7ff;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);
  }

  &.has-stock-conflict {
    border-color: #f59e0b;
    background: #fffaf0;
    box-shadow: 0 2px 10px rgba(245, 158, 11, 0.12);
  }

  .card-header-pro {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;

    .product-title {
      font-size: 0.8rem;
      font-weight: 700;
      color: #0f172a;
      margin: 0;
      flex: 1;
      line-height: 1.2;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      white-space: normal;
    }

    .unit-badge {
      font-size: 0.55rem;
      padding: 0.2rem 0.35rem;
      border-radius: 4px;
      text-transform: uppercase;
      flex-shrink: 0;
    }
  }

  .stock-inline-warning {
    background: #fff1d6;
    color: #9a3412;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 0.62rem;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .product-info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    background: #f8fafc;
    padding: 4px 8px;
    border-radius: 6px;
    margin-bottom: 8px;

    .info-item {
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .info-label {
        font-size: 0.5rem;
        font-weight: 700;
        color: #94a3b8;
        letter-spacing: 0.4px;
        margin-bottom: 0px;
      }
      .info-value {
        font-size: 0.65rem;
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .estimate-qty {
        color: #2563eb;
      }
      .estimate-total {
        color: #f97316;
      }
    }

    &.product-info-grid-estimate {
      grid-template-columns: 0.75fr 0.9fr 0.9fr minmax(0, 1.45fr);
    }
  }

  .card-actions-pro {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 6px;

    .price-box {
      flex: 1.1;
      min-width: 0;
      .price-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 2px;
        .price-label { font-size: 0.5rem; font-weight: 700; color: #64748b; }
        .last-price { 
          font-size: 0.5rem; 
          font-weight: 700; 
          color: #3b82f6; 
          cursor: pointer;
        }
      }
      .input-price-pro {
        height: 30px;
        font-weight: 700;
        font-size: 0.85rem;
        border-radius: 4px !important;
        text-align: right;
        background: #f1f5f9;
        border: 1px solid #e2e8f0;
        &.has-value { background: #fffbeb; border-color: #f59e0b; color: #92400e; }
      }
    }

    .quantity-box {
      flex: 1;
      min-width: 0;
      .qty-label { display: block; font-size: 0.5rem; font-weight: 700; color: #64748b; margin-bottom: 2px; text-align: right; }
      
      .input-qty-pro {
        height: 30px;
        font-weight: 700;
        text-align: center;
        border-radius: 0 !important;
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-left: none;
        border-right: none;
        font-size: 0.85rem;
        &.has-value { background: #fff7ed; color: #c2410c; }
      }

      .btn-qty-pro {
        width: 30px;
        height: 30px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px !important;
        font-size: 0.75rem;
      }
    }
  }

  .variations-panel {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #e2e8f0;
    
    .variation-item {
      margin-bottom: 6px;
      .variation-label { font-size: 0.6rem; font-weight: 700; color: #64748b; }
      .variation-history { font-size: 0.55rem; color: #3b82f6; font-weight: 600; cursor: pointer; }
    }
  }
}

.text-success { color: #10b981 !important; }
.text-danger { color: #ef4444 !important; }

/* Footer & Pagination Modern */
.footer-pro {
  border-radius: 0 0 12px 12px;
}

.summary-selection {
  line-height: 1.2;
  .item-resumo {
    font-size: 0.65rem;
    color: #64748b;
    text-transform: uppercase;
    strong { color: #1e293b; }
  }
}

.pagination-modern {
  .page-item {
    .page-link {
      border: none;
      background: transparent;
      color: #64748b;
      font-weight: 800;
      font-size: 0.9rem;
      padding: 0.4rem 0.6rem;
      &:focus { box-shadow: none; }
    }
    &.disabled .page-link {
      color: #cbd5e0;
      background: transparent;
    }
    &.active .page-link {
      background: #f1f5f9;
      color: #3b82f6;
      border-radius: 8px;
    }
  }
}

.btn-concluir {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 1rem;
  background: #20a8d8;
  border: none;
  transition: all 0.2s;
  &:active { transform: scale(0.98); }
}

.bg-info-light {
    background-color: #e0f2fe;
}

.btn-add-product {
    border-radius: 8px;
    font-weight: 700;
    font-size: 0.75rem;
    padding: 0.5rem 1rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background-color: #3b82f6;
    &:hover { background-color: #2563eb; }
}

.items-header-professional {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  .icon-indicator {
    width: 4px;
    height: 24px;
    border-radius: 2px;
    margin-right: 12px;
  }
}

.btn-add-modern-pro {
  background: #4dbd74;
  border: none;
  color: white;
  border-radius: 8px;
  padding: 8px 18px;
  font-weight: 800;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  box-shadow: 0 4px 12px rgba(32, 168, 216, 0.3);
  transition: all 0.2s ease;
  &:hover {
    background: #4dbd74;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 6px 15px rgba(32, 168, 216, 0.4);
  }
}

.item-card-pedido-wrap {
  padding: 0 4px 0 0; /* Forced left padding to 0 */
  width: 100%;
  box-sizing: border-box;
}

.item-card-pedido {
  background: #ffffff;
  border-radius: 12px;
  padding: 10px;
  margin: 0 0 10px 0;
  border: 1px solid #edf2f7;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  max-width: calc(100vw - 10px); /* Ensuring it stays within viewport */

  &:active {
    background-color: #f8fafc;
    transform: translateY(1px);
  }

  .card-header-pedido {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
    width: 100%;
    
    .title-section {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      padding-right: 5px;

      .product-name {
        font-size: 0.85rem;
        font-weight: 800;
        color: #1a202c;
        margin: 0;
        line-height: 1.2;
        display: block;
        width: 100%;
        white-space: normal;
        word-wrap: break-word;
      }
      .group-name {
        font-size: 0.6rem;
        color: #718096;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        display: block;
        margin-top: 1px;
        white-space: normal;
        word-wrap: break-word;
        width: 100%;
      }
    }
    
    .btn-delete-item {
      padding: 0.4rem;
      border-radius: 8px;
      border: 1px solid #fee2e2;
      background: #fff;
      margin-top: -2px;
      margin-left: 2px;
      flex-shrink: 0;
      &:hover { background: #fee2e2; }
    }
  }

  .card-body-pedido {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
    border-radius: 8px;
    padding: 8px;
    width: 100%;
    min-width: 0;
    
    .info-group {
      display: flex;
      flex: 2;
      justify-content: space-between;
      margin-right: 5px;
      min-width: 0;
      
      .info-item {
        display: flex;
        flex-direction: column;
        min-width: 0;
        flex: 1;
        padding-right: 4px;
        .label {
          font-size: 0.5rem;
          font-weight: 800;
          color: #a0aec0;
          margin-bottom: 1px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }
        .value {
          font-size: 0.75rem;
          font-weight: 800;
          color: #2d3748;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .rep-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-left: 5px;
      border-left: 1px solid #e2e8f0;
      flex-shrink: 0;
      .label {
        font-size: 0.45rem;
        font-weight: 800;
        color: #a0aec0;
        margin-bottom: 3px;
        letter-spacing: 0.3px;
      }
    }
  }
}

/* Custom Scrollbar */
.modal-body::-webkit-scrollbar {
  width: 6px;
}
.modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 10px;
}

/* Modern Tab Header Styles */
.modern-tabs-container {
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.02);

  .nav-tabs {
    border-bottom: none;
    background: transparent;
    padding: 2px 4px;
    display: flex;
    justify-content: space-around;
  }
  
  .nav-item {
    margin-bottom: 0;
    flex: 1;
  }

  .nav-link {
    border: none !important;
    border-radius: 0 !important;
    padding: 4px 5px !important;
    transition: all 0.3s ease;
    background: transparent !important;
    position: relative;
    
    &.modern-tab-active {
      font-weight: 800;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 20%;
        right: 20%;
        height: 3px;
        background: #20a8d8;
        border-radius: 10px 10px 0 0;
      }
      .icons {
        color: #20a8d8;
        transform: translateY(-2px);
      }
      .tab-label {
        color: #20a8d8;
      }
    }

    &.modern-tab-active-green {
      font-weight: 800;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 20%;
        right: 20%;
        height: 3px;
        background: #4dbd74;
        border-radius: 10px 10px 0 0;
      }
      .icons {
        color: #4dbd74;
        transform: translateY(-2px);
      }
      .tab-label {
        color: #4dbd74;
      }
    }

    &.modern-tab-inactive {
      opacity: 0.6;
      .icons {
        color: #94a3b8;
      }
      .tab-label {
        color: #94a3b8;
      }
    }
  }

  .tab-content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    .icons {
      font-size: 1.1rem !important;
      transition: transform 0.3s ease;
    }
    
    .tab-label {
      font-size: 0.6rem;
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  }
}

/* Dark Mode Support for Pedido Cadastro */
.pedido-dark {
  background-color: #1e1e2d !important;
  color: #e2e8f0 !important;

  .bg-white { background-color: #2d3748 !important; border-color: #4a5568 !important; }
  .bg-light { background-color: #1a202c !important; border-color: #4a5568 !important; }
  .bg-gray-100 { background-color: #1e1e2d !important; }
  
  .text-dark { color: #f7fafc !important; }
  .text-muted { color: #a0aec0 !important; }

  /* Top sticky navbar */
  .sticky-top.bg-white {
    background-color: #1e1e2d !important;
    border-bottom-color: #2d3748 !important;
  }

  /* Summary Card */
  .sticky-top .px-1 > .d-flex {
    background-color: #2d3748 !important;
    border-color: #4a5568 !important;
  }
  .sticky-top .px-1 > .d-flex .text-dark {
    color: #f7fafc !important;
  }
  .sticky-top .px-1 > .d-flex .text-muted {
    color: #a0aec0 !important;
  }
  .sticky-top .px-1 > .d-flex .text-primary {
    color: #63b3ed !important;
  }
  
  /* Tabs */
  .modern-tabs-container {
    background: #1e1e2d !important;
    border-top-color: #2d3748 !important;
  }
  .modern-tabs-container .nav-link.active,
  .modern-tabs-container .nav-link.modern-tab-active,
  .modern-tabs-container .nav-link.modern-tab-active-green {
    background-color: #20a8d8 !important;
  }
  .modern-tabs-container .nav-link.active,
  .modern-tabs-container .nav-link.active .icons,
  .modern-tabs-container .nav-link.active .tab-label,
  .modern-tabs-container .nav-link.modern-tab-active .icons,
  .modern-tabs-container .nav-link.modern-tab-active .tab-label,
  .modern-tabs-container .nav-link.modern-tab-active-green .icons,
  .modern-tabs-container .nav-link.modern-tab-active-green .tab-label {
    color: #ffffff !important;
  }
  
  /* Atalhos Buttons and btn-white */
  .btn-white {
    background-color: #2d3748 !important;
    border-color: #4a5568 !important;
    color: #e2e8f0 !important;
  }
  .btn-white:hover {
    background-color: #4a5568 !important;
    color: #ffffff !important;
  }
  
  /* Inputs inside the form */
  .form-control-modern, .input-price-pro, .input-qty-pro {
    background-color: #1a202c !important;
    color: #e2e8f0 !important;
    border-color: #4a5568 !important;
  }
  .form-control-modern:focus {
    border-color: #63b3ed !important;
  }

  /* Item cards */
  .items-header-professional {
    background-color: #2d3748 !important;
    border-color: #4a5568 !important;
  }

  .item-card-pedido {
    background-color: #2d3748 !important;
    border-color: #4a5568 !important;
    &:active { background-color: #1a202c !important; }
    
    .card-header-pedido .product-name { color: #f7fafc !important; }
    .card-body-pedido { background: #1a202c !important; }
    .info-item .value { color: #e2e8f0 !important; }
    .rep-section { border-left-color: #4a5568 !important; }
  }

  /* Fix hardcoded borders */
  .border-top { border-top-color: #4a5568 !important; }
  .border-bottom { border-bottom-color: #4a5568 !important; }
}

/* Dark Mode Support for Modals (teleported to body) */
.pedido-modal-dark .modal-content {
  background-color: #1e1e2d !important;
  color: #e2e8f0 !important;
}
.pedido-modal-dark .product-card-pro {
  background-color: #2d3748 !important;
  border-color: #4a5568 !important;
}
.pedido-modal-dark .product-card-pro .product-title { color: #f7fafc !important; }
.pedido-modal-dark .product-card-pro .info-label { color: #a0aec0 !important; }
.pedido-modal-dark .product-card-pro .info-value { color: #e2e8f0 !important; }
.pedido-modal-dark .product-card-pro .variation-label { color: #a0aec0 !important; }
.pedido-modal-dark .product-card-pro .variation-history { color: #63b3ed !important; }
.pedido-modal-dark .product-card-pro .qty-label { color: #a0aec0 !important; }
.pedido-modal-dark .product-card-pro .price-label { color: #a0aec0 !important; }
.pedido-modal-dark .product-card-pro .product-info-grid { background-color: #1a202c !important; }
.pedido-modal-dark .product-card-pro .estimate-qty { color: #63b3ed !important; }
.pedido-modal-dark .product-card-pro .estimate-total { color: #fbd38d !important; }
.pedido-modal-dark .product-card-pro.is-selected { background-color: #1e1e2d !important; border-color: #3b82f6 !important; }
.pedido-modal-dark .product-card-pro.has-stock-conflict { background-color: #1e1e2d !important; border-color: #f59e0b !important; }

.pedido-modal-dark .footer-pro {
  background-color: #2d3748 !important;
  border-top-color: #4a5568 !important;
}
.pedido-modal-dark .bg-white { background-color: #2d3748 !important; border-color: #4a5568 !important; }
.pedido-modal-dark .bg-light { background-color: #1a202c !important; border-color: #4a5568 !important; }
.pedido-modal-dark .text-dark { color: #f7fafc !important; }
.pedido-modal-dark .text-muted { color: #a0aec0 !important; }
.pedido-modal-dark .border-top { border-top-color: #4a5568 !important; }
.pedido-modal-dark .border-bottom { border-bottom-color: #4a5568 !important; }

.pedido-modal-dark .modern-search {
  background-color: #1a202c !important;
  color: #e2e8f0 !important;
  border-color: #4a5568 !important;
}
.pedido-modal-dark .btn-search-back {
  background-color: #2d3748 !important;
  border-color: #4a5568 !important;
  color: #e2e8f0 !important;
}
.pedido-modal-dark .item-resumo { color: #f7fafc !important; }
.pedido-modal-dark .item-resumo.text-primary { color: #63b3ed !important; }

.pedido-modal-dark .form-control-modern, 
.pedido-modal-dark .input-price-pro, 
.pedido-modal-dark .input-qty-pro {
  background-color: #1a202c !important;
  color: #e2e8f0 !important;
  border-color: #4a5568 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/pedidovenda/PedidoVendaCadastro.vue